<template>
    <v-container fluid>
        <v-toolbar dense dark color="primary" class="text-center mb-2" >
            <v-toolbar-title>SandBox Dispatch</v-toolbar-title>
        </v-toolbar>
        <v-row class="mr-3" style="margin: 0px; padding-top: 0px; padding-right: 0px;">
            <v-row>
                <v-col cols="5" fixed style="width: 40%; ;height: 400px;position: fixed;">
                    <v-card height="400px">
                        <v-toolbar dark color="secondary" dense>
                            <v-toolbar-title class="white--text">Order Line Up</v-toolbar-title>
                            <v-btn color="#fff" class="ml-3" small outlined @click="dispatchReports.Show = true">
                                <v-icon>mdi-file-chart</v-icon>
                                Reports
                            </v-btn>
                            <v-spacer />
                            <v-btn color="#fff" class="mr-3" small outlined
                                @click="dltOrdersConfirm"><v-icon>mdi-delete</v-icon> Orders</v-btn>
                            <v-btn color="#fff" class="mr-3" small outlined
                                @click="refreshTempPendingOrders"><v-icon>mdi-refresh</v-icon> Readings</v-btn>
                            <v-icon @click="openOrderForm()" class="mr-5">mdi-plus</v-icon>
                            <v-icon >mdi-refresh</v-icon>
                        </v-toolbar>
                        <v-container style="margin: 0px; padding: 0px">
                            <v-row style="margin: 0px; padding: 0px">
                                <v-col cols="5">
                                    <v-text-field v-model="search" label="Search" class="mt-3" dense hide-details
                                        clearable></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-select dense hide-details class="mt-3" v-model="limitBy" :items="filterByItems"
                                        @change="HrsSelect" label="Limit search to"></v-select>
                                </v-col>
                                <v-col cols="3">
                                    <v-combobox v-model="type" :items="types" class="mt-3" :item-text="'Type'"
                                        :item-value="'id'" label="Station Type" auto-select-first hide-details
                                        dense></v-combobox>
                                </v-col>
                            </v-row>
                            <v-row dense class="lineUpHeader" style="margin-top: 0px; padding-top: 0px">
                                <v-col cols="12">
                                    <v-simple-table>
                                        <thead>
                                            <tr>
                                                <th>
                                                    Order ID
                                                    <v-icon x-small @click="sortOrderDown">mdi-arrow-down-thick</v-icon>
                                                    <v-icon x-small @click="sortOrderUp">mdi-arrow-up-thick</v-icon>
                                                </th>
                                                <th>
                                                    Terminal
                                                    <v-icon x-small @click="sortTerminalDown
                                                        ">mdi-arrow-down-thick</v-icon>
                                                    <v-icon x-small @click="sortTerminalUp">mdi-arrow-up-thick</v-icon>
                                                </th>
                                                <th>
                                                    Station
                                                    <v-icon x-small
                                                        @click="sortStationDown">mdi-arrow-down-thick</v-icon>
                                                    <v-icon x-small @click="sortStationUp">mdi-arrow-up-thick</v-icon>
                                                </th>
                                                <th>
                                                    City
                                                    <v-icon x-small @click="sortCityDown">mdi-arrow-down-thick</v-icon>
                                                    <v-icon x-small @click="sortCityUp">mdi-arrow-up-thick</v-icon>
                                                </th>
                                            </tr>
                                        </thead>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </v-container>
                        <div v-if="this.dataLoading" class="spinner">
                            <div class="sk-chase">
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                            </div>
                        </div>
                        <v-list subheader style="max-height: 500px" class="overflow-y-auto" v-else>
                            <draggable v-model="filteredOrders" group="orders" style="max-height: 450px"
                                @remove="remove" @end="endOrder" @add="addLineUp" :disabled="block" id="line-up">
                                <template v-for="order in filteredOrders">
                                    <v-list-item :key="order.OrderID" class="orderText" @dragstart="dragOrder"
                                        @contextmenu.prevent="
                                            $refs.lineUpMenu.open($event, order)
                                            " :style="order.Validate
                                                ? 'background:#dceafc;'
                                                : 'background:#fff;'
                                                ">
                                        <div style="width: 5%;">
                                            {{ order.RTHrs }}
                                        </div>
                                        <div style="width: 5%;">
                                            {{ order.ROHrs }}
                                        </div>
                                        <div style="width: 10%;">
                                            <abbr v-if="order.isSpecific > 0" style="text-decoration: none;" :title="'Product : ' +
                                                order.SpecificProduct
                                                ">
                                                <v-icon small color="#FFEE58">mdi-star</v-icon>
                                            </abbr>
                                            <abbr :title="order.DispatchComments" :style="order.AutomaticCreation == 1
                                                ? 'background-color: #FFCACA;border-radius:15px;padding:4px;'
                                                : 'background-color: transparent;'
                                                ">
                                                {{ order.OrderID }}
                                            </abbr>
                                        </div>
                                        <div @click="
                                            getDriverShiftByTerminaBadge(
                                                order
                                            )
                                            ">
                                            <abbr :title="order.DateRequested">
                                                <v-icon :color="order.TerminalColor">mdi-circle</v-icon>
                                            </abbr>
                                        </div>
                                        <div style="width: 30%" class="ml-6">
                                            {{ order.Terminal }}
                                        </div>
                                        <div style="width: 30%">
                                            {{ order.Station }}
                                        </div>
                                        <div style="width: 20%">
                                            {{ order.StationCity }}
                                        </div>
                                        <div style="width: 5%">
                                            <abbr style="text-decoration: none;" :title="'Preload: ' +
                                                order.PreloadOrderID
                                                ">
                                                <v-icon small color="green" v-if="
                                                    order.OrderStatus ==
                                                    'PRLDHELD'
                                                ">
                                                    mdi-square
                                                </v-icon>
                                            </abbr>
                                        </div>
                                    </v-list-item>
                                </template>
                            </draggable>
                        </v-list>
                    </v-card>
                </v-col>
            </v-row>

            <v-col :cols="width" style="margin: 0px; padding-top: 0px; padding-right: 0px">
                <v-divider />
                <v-card>
                    <v-toolbar dark color="secondary" height="40px">
                        <v-spacer />
                        <v-toolbar-title class="white--text">Dispatch</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-progress-circular v-if="shiftLoading" indeterminate></v-progress-circular>
                    </v-toolbar>
                    <v-container grid-list-xs fluid>
                        <v-row class="mx-3" justify="center" align-content="center">
                            <v-col cols="7">
                                <v-combobox prepend-icon="mdi-refresh" @click:prepend="loadShifts(true)"
                                    v-model="header" :items="shift_headers" :item-text="'ShiftDate'"
                                    :item-value="'ShiftId'" label="Select Shift" class="scroller" auto-select-first
                                    @change="loadShifts(true)"></v-combobox>
                            </v-col>
                            <v-col cols="1" class="mt-3">
                                <v-menu transition="slide-x-transition" bottom right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="deep-orange" color="primary" dark v-bind="attrs" v-on="on">
                                            <v-icon>mdi-printer </v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <v-list-item v-for="(item, i) in reportTitles" :key="i"
                                            class="report-titles-container">
                                            <v-list-item-title @click="
                                                item.title ==
                                                    'Get Dispatch Report'
                                                    ? getDispatchReport(
                                                        0,
                                                        false
                                                    )
                                                    : getDispatchReport(
                                                        0,
                                                        true
                                                    )
                                                ">
                                                {{ item.title }}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-col>
                            <div v-if="header">
                                <v-col v-if="
                                    headerComment == null ||
                                    headerComment == ''
                                " cols="1" class="mt-3 ml-3">
                                    <v-btn @click="openComentDialog('header', '')">
                                        <v-icon color="primary">mdi-comment-off-outline</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col v-if="headerComment" cols="1" class="mt-3 ml-3">
                                    <v-btn @click="openComentDialog('header', '')">
                                        <v-icon color="primary">mdi-comment-eye</v-icon>
                                    </v-btn>
                                </v-col>
                            </div>
                        </v-row>
                    </v-container>
                </v-card>
                <v-toolbar dark color="secondary" height="40px" class="mt-2">
                    <template v-for="yard in yards">
                        <v-col :key="yard.PrincipalRegionID">
                            <v-toolbar-items class="orderText" :class="{
                                yardSelected: hasYard(
                                    yard.PrincipalRegionID
                                )
                            }" @click="toggleYard(yard.PrincipalRegionID)">
                                {{ yard.PrincipalRegion }}:
                                {{ yard.Total }}
                            </v-toolbar-items>
                        </v-col>
                    </template>
                </v-toolbar>
                <v-row>
                    <template v-for="(shift, index) in shifts">
                        <v-col cols="12" :key="shift.ShiftDetail" :id="shift.ShiftDetail">
                            <v-toolbar dark :color="shift.colorDistpatch" height="45px">
                                <v-btn color="#fff" icon @click="
                                    shift.DriverEleosApp == 1
                                        ? checkSyncPlatforms(
                                            shift.ShiftDetail,
                                            'not-apply',
                                            'refresh-orders'
                                        )
                                        : getOrdersByShiftDetail(
                                            shift.ShiftDetail,
                                            index,
                                            '',
                                            'just-refresh'
                                        )
                                    ">
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                                <div
                                    style="display: flex;align-items: center;width: 100%;gap: 10px;padding-right: 20px;">
                                    <div>
                                        <v-icon v-if="shift.Finalize == 1">mdi-shield-lock</v-icon>
                                        <v-icon v-else>mdi-shield-lock-open-outline</v-icon>
                                    </div>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <p class="shiftText" v-bind="attrs" v-on="on"><v-icon>mdi-gas-station-in-use</v-icon></p>
                                        </template>
                                        <div v-for="last in shift.LastContained">
                                            <span class="shiftText">{{ last.Product +': '+ last.DispatchedQuantity}}</span><br>
                                        </div>
                                    </v-tooltip>
                                    <p class="shiftText">{{ shift.Driver }}</p>

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <p class="shiftText" v-bind="attrs" v-on="on">
                                                <a :href="'https://my.geotab.com/upt/#map,liveVehicleIds:!(' + shift.TruckGeotabID + ')'"
                                                    style="text-decoration: none; color:#fff;" target="_blank">{{
                                                        shift.Truck }}</a>
                                            </p>
                                        </template>
                                        <span class="shiftText">
                                            Open from geotab
                                        </span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <p class="shiftText" v-bind="attrs" v-on="on">
                                                {{ shift.Trailer }}
                                            </p>
                                        </template>
                                        <span class="shiftText">
                                            {{
                                                shift.SpecificProduct == null
                                                    ? 'Specific Product: not apply'
                                                    : 'Specific Product: ' +
                                                    shift.SpecificProduct
                                            }}
                                        </span>
                                    </v-tooltip>
                                    <p class="shiftText">{{ shift.Yard }}  <span>{{shift.ExitTime}}</span></p>
                                    <p class="shiftText">
                                        {{ shift.StartTimeFmmt }}
                                    </p>
                                    <p class="shiftText">
                                        {{ shift.HrsAviable }}/{{
                                            shift.TargetHours
                                        }}
                                    </p>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <a v-bind="attrs" v-on="on" :href="'/dispatch/shift-assignment#' +
                                                shift.ShiftDetail
                                                " class="shiftText" style="color: #fff;" target="_blank">
                                                {{ shift.ShiftDetail }}
                                            </a>
                                        </template>
                                        <span class="shiftText">Edit In Shift Assignment</span>
                                    </v-tooltip>
                                    <p class="shiftText" v-if="shift.DriverTrainer != null">
                                        <b>Trainer by:</b>
                                        {{ shift.DriverTrainer }}
                                    </p>
                                </div>
                                <div class="text-center" style="display: flex; gap: 10px;">
                                    <div v-if="
                                        shift.Finalize != 1 &&
                                        shift.DispatchFinalize != 1
                                    ">
                                        <v-badge color="green" overlap :content="shift.SentMailCounter"
                                            :value="shift.SentMailCounter != 0" offset-x="14" offset-y="14">
                                            <v-tooltip top>
                                                <template v-slot:activator="{
                                                    on,
                                                    attrs
                                                }">
                                                    <v-btn @click="
                                                        checkOriginOfLoads(
                                                            shift,
                                                            index
                                                        )
                                                        " :color="shift.ColorSTDBtn
                                                            " small dark v-bind="attrs" v-on="on">
                                                        <v-icon>mdi-send</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Send To Driver</span>
                                            </v-tooltip>
                                        </v-badge>
                                    </div>
                                    <v-menu transition="slide-x-transition" bottom right offset-y
                                        :close-on-content-click="false" :nudge-width="150">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="#4f83cc" dark small v-bind="attrs" v-on="on"
                                                style="text-transform: capitalize;">
                                                <v-icon>mdi-tools</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-list
                                                style="display: grid;grid-template-columns: repeat(3, 1fr);justify-items: center;">
                                                <v-list-item class="marpad-0">
                                                    <v-col class="marpad-0" v-if="
                                                        shift.ShiftAssmtComments ==
                                                        null ||
                                                        shift.ShiftAssmtComments ==
                                                        ''
                                                    ">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }">
                                                                <v-btn v-bind="attrs
                                                                    " v-on="on" color="#4f83cc" small dark @click="
                                                                        openComentDialog(
                                                                            'shift',
                                                                            shift
                                                                        )
                                                                        ">
                                                                    <v-icon>mdi-comment-off-outline</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Shift
                                                                Comments</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col class="marpad-0" v-if="
                                                        shift.ShiftAssmtComments
                                                    ">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }">
                                                                <v-btn v-bind="attrs
                                                                    " v-on="on" color="#4f83cc" small dark @click="
                                                                        openComentDialog(
                                                                            'shift',
                                                                            shift
                                                                        )
                                                                        ">
                                                                    <v-icon>mdi-comment-eye
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Shift
                                                                Comments</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-list-item>

                                                <v-list-item class="marpad-0">
                                                    <v-col class="marpad-0">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }">
                                                                <v-btn color="#4f83cc" small dark @click="
                                                                    openLastETA(
                                                                        shift.TruckID
                                                                    )
                                                                    " v-bind="attrs
                                                                        " v-on="on">
                                                                    <v-icon>mdi-truck</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Last ETA
                                                                List</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-list-item>

                                                <v-list-item class="marpad-0">
                                                    <v-col class="marpad-0">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }">
                                                                <v-btn v-bind="attrs
                                                                    " v-on="on" color="#4f83cc" small dark @click="
                                                                        chargeModalTrailer(
                                                                            index,
                                                                            shift
                                                                        )
                                                                        ">
                                                                    <v-icon>mdi-eye-outline</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>See Trailer
                                                                Info</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-list-item>

                                                <v-list-item v-if="
                                                    shift.Finalize != 1 &&
                                                    shift.DispatchFinalize !=
                                                    1
                                                " class="marpad-0">
                                                    <v-col class="marpad-0">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }">
                                                                <v-btn v-model="multiPreloads[
                                                                    shift
                                                                        .ShiftDetail
                                                                ]
                                                                    " @click="
                                                                        multiPreloadOrderActive(
                                                                            shift.ShiftDetail,
                                                                            index
                                                                        )
                                                                        " :color="shift.ColorMultiPreloadBtn
                                                                            " small dark v-bind="attrs
                                                                            " v-on="on">
                                                                    <v-icon>mdi-checkbox-multiple-marked</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Multi-Preload</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-list-item>

                                                <v-list-item v-if="
                                                    shift.Finalize != 1 &&
                                                    shift.DispatchFinalize !=
                                                    1 &&
                                                    shift.DriverEleosApp ==
                                                    1
                                                " class="marpad-0">
                                                    <v-col class="marpad-0">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }">
                                                                <v-btn @click="
                                                                    checkCurrentOrderInProgress(
                                                                        shift,
                                                                        index
                                                                    )
                                                                    " color="#4f83cc" small dark v-bind="attrs
                                                                        " v-on="on">
                                                                    <v-icon>mdi-sort-bool-ascending-variant</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Forced
                                                                Completion</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-list-item>

                                                <v-list-item class="marpad-0">
                                                    <v-col class="marpad-0">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }">
                                                                <v-btn v-bind="attrs
                                                                    " v-on="on" color="#4f83cc" small dark @click="
                                                                        getDriverMail(
                                                                            shift.ShiftDetail,
                                                                            index
                                                                        )
                                                                        ">
                                                                    <v-icon>mdi-download-box</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Download Driver
                                                                Shift
                                                                Document</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-list-item>

                                                <v-list-item v-if="
                                                    shift.DriverEleosApp ==
                                                    1
                                                " class="marpad-0">
                                                    <v-col class="marpad-0" v-if="
                                                        shift.DispatchFinalize ==
                                                        0
                                                    ">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }">
                                                                <v-btn v-bind="attrs
                                                                    " v-on="on" @click="
                                                                        validateShiftCompletion(
                                                                            shift,
                                                                            index,
                                                                            'close'
                                                                        )
                                                                        " color="#4f83cc" small dark>
                                                                    <v-icon>mdi-lock-check</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Close
                                                                Shift</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col class="marpad-0" v-else-if="
                                                        shift.DispatchFinalize ==
                                                        1
                                                    ">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }">
                                                                <v-btn v-bind="attrs
                                                                    " v-on="on" @click="
                                                                        validateShiftCompletion(
                                                                            shift,
                                                                            index,
                                                                            'open'
                                                                        )
                                                                        " color="#4f83cc" small dark>
                                                                    <v-icon>mdi-lock-open-check</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Open
                                                                Shift</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-list-item>
                                            </v-list>
                                        </v-card>
                                    </v-menu>
                                </div>
                            </v-toolbar>
                            <v-toolbar color="#e3e3e3" height="25px">
                                <template v-for="badge in driverBadges[index]">
                                    <v-col cols="1" :key="badge.id" style="margin-left: -15px">
                                        <abbr style="text-decoration: none;" :title="badge.Terminal">
                                            <v-icon :color="badge.TerminalColor">mdi-circle</v-icon>
                                        </abbr>
                                    </v-col>
                                </template>
                            </v-toolbar>
                            <div>
                                <v-list v-if="shift.View">
                                    <draggable v-model="shiftOrders[index]" group="orders" @start="startOrder(index)"
                                        @end="endOrder" @add="addOrder(index)" @remove="removeOrder(index)"
                                        @update="changeOrder" :disabled="shift.Finalize == 1 ||
                                            shift.DispatchFinalize == 1
                                            " ghost-class="ghost" style="min-height: 200px" :id="shift.ShiftDetail">
                                        <div v-for="order in shiftOrders[index]" :key="order.OrderID"
                                            style="font-size: 10.5px;border-bottom: 1px solid lightgrey;"
                                            :class="order.UnfinishedLoadClass">
                                            <v-list-item v-bind:key="order.OrderID"
                                                style="margin-bottom: 1px; background-color:#ddd;" :disabled="true"
                                                v-if="shift.Finalize == 1">
                                                <div v-if="
                                                    shift.DriverEleosApp ==
                                                    1
                                                ">
                                                    <div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-if="
                                                            order.UnknownOrigins !=
                                                            '' &&
                                                            order.UnknownOrigins !=
                                                            null
                                                        ">
                                                            <v-tooltip right>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="#2980B9" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-help-circle
                                                                    </v-icon>
                                                                </template>
                                                                <span>This load
                                                                    currently
                                                                    belongs to
                                                                    another
                                                                    Shift (in
                                                                    Eleos App):
                                                                    {{
                                                                        order.UnknownOrigins
                                                                    }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-else-if="
                                                            order.OrdLoadStatus ==
                                                            'READYTOSEND' ||
                                                            order.OrdLoadStatus ==
                                                            null
                                                        ">
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="orange darken-2" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-clock-check-outline
                                                                    </v-icon>
                                                                </template>
                                                                <span>Ready To
                                                                    Send</span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-else-if="
                                                            order.OrdLoadStatus ==
                                                            'DONE'
                                                        ">
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="green darken-2" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-check-circle-outline
                                                                    </v-icon>
                                                                </template>
                                                                <span>
                                                                    {{
                                                                        order.BOLNumber !=
                                                                            null
                                                                            ? 'Done' +
                                                                            ' / ' +
                                                                            'BOL#: ' +
                                                                            order.BOLNumber
                                                                            : 'Done'
                                                                    }}
                                                                </span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-else-if="
                                                            order.OrdLoadStatus ==
                                                            'INPROGRESS'
                                                        ">
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="blue darken-2" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-progress-clock
                                                                    </v-icon>
                                                                </template>
                                                                <span>
                                                                    {{
                                                                        order.BOLNumber !=
                                                                            null
                                                                            ? 'In Progress' +
                                                                            ' / ' +
                                                                            'BOL#: ' +
                                                                            order.BOLNumber
                                                                            : 'In Progress'
                                                                    }}
                                                                </span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-else-if="
                                                            order.OrdLoadStatus ==
                                                            'FORCEDCOMPLETION'
                                                        ">
                                                            <v-tooltip right>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="teal darken-2" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-alert-circle-check
                                                                    </v-icon>
                                                                </template>
                                                                <span>
                                                                    {{
                                                                        order.ReasonForChange !=
                                                                            null
                                                                            ? 'Forced Completion' +
                                                                            ' / ' +
                                                                            'By: ' +
                                                                            order.ChangeMadeBy +
                                                                            ' / ' +
                                                                            'Reasons: ' +
                                                                            order.ReasonForChange
                                                                            : 'Forced Completion'
                                                                    }}
                                                                </span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-else-if="
                                                            order.OrdLoadStatus ==
                                                            'NOTSTARTED'
                                                        ">
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="gray darken-2" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-dots-horizontal-circle-outline
                                                                    </v-icon>
                                                                </template>
                                                                <span>Not
                                                                    Started</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="shifts5">
                                                    {{ order.LoadNum }}
                                                </div>
                                                <div class="shifts5">
                                                    {{ order.LoadNumOrd }}
                                                </div>
                                                <div class="shifts10">
                                                    {{ order.OrderID }}
                                                </div>
                                                <div class="shifts5">
                                                    <v-icon :color="order.TerminalColor
                                                        ">mdi-circle</v-icon>
                                                </div>
                                                <div class="shifts20">
                                                    {{ order.Terminal }}
                                                </div>
                                                <v-alert class="shifts25 my-auto mx-1" v-if="
                                                    order.dpColor == 'blue'
                                                " :color="order.dpColor" dense text style="font-size: 11px">
                                                    {{ order.Station }}
                                                </v-alert>
                                                <div class="shifts25 my-auto mx-1" v-else>
                                                    {{ order.Station }}
                                                </div>
                                                <div class="shifts15">
                                                    {{ order.StationCity }}
                                                </div>
                                                <div class="shifts5">
                                                    {{ order.ROHrs }}
                                                </div>
                                                <div class="shifts5">
                                                    {{ order.GoalPost }}
                                                </div>
                                                <div v-if="
                                                    order.OrderStatus ==
                                                    'PRLDISPAT'
                                                ">
                                                    <v-icon color="green" small dense>mdi-square</v-icon>PRD
                                                </div>
                                                <div v-if="
                                                    order.OrderStatus ==
                                                    'PRELOAD'
                                                ">
                                                    <v-icon color="orange" small dense>mdi-square</v-icon>PRE
                                                </div>
                                            </v-list-item>
                                            <v-list-item v-else v-bind:key="order.OrderID" v-bind:style="shift.DriverEleosApp != 1
                                                ? 'margin-bottom: 1px; background-color:#fff;border-left: 8px solid transparent;'
                                                : order.OrdLoadStatus ==
                                                    'READYTOSEND' &&
                                                    order.ShortLoad == 1
                                                    ? 'margin-bottom: 1px;background-color: #FFEDAA;color: #000;border-left: 8px solid transparent;'
                                                    : order.UnknownOrigins !=
                                                        '' &&
                                                        order.UnknownOrigins !=
                                                        null
                                                        ? 'margin-bottom: 1px;background-color: #D7BDE2;color: #000;border-left: 8px solid transparent;'
                                                        : order.OrdLoadStatus ==
                                                            'DONE' ||
                                                            order.OrdLoadStatus ==
                                                            'FORCEDCOMPLETION'
                                                            ? 'margin-bottom: 1px; background-color:#ddd;border-left: 8px solid transparent;'
                                                            : order.OrdActiveOrder ==
                                                                1 &&
                                                                (order.ShiftDetail ==
                                                                    order.EleosShiftDetail ||
                                                                    order.UnknownOrigins ==
                                                                    '' ||
                                                                    order.UnknownOrigins ==
                                                                    null)
                                                                ? 'margin-bottom: 1px; background-color:#fff; border-left: 8px solid #FFD500;'
                                                                : 'margin-bottom: 1px; background-color:#fff;border-left: 8px solid transparent;'
                                                " @contextmenu.prevent="
                                                    multiPreloads[
                                                        shift.ShiftDetail
                                                    ]
                                                        ? $refs.menuMulti.open(
                                                            $event
                                                        )
                                                        : $refs.menu.open(
                                                            $event,
                                                            order
                                                        )
                                                    ">
                                                <v-checkbox v-bind:style="multiPreloads[
                                                    shift.ShiftDetail
                                                ] &&
                                                    order.OrderStatus ==
                                                    'DISPATCHED' &&
                                                    order.FinalizeOrder != 1
                                                    ? 'display: block;'
                                                    : 'display: none;'
                                                    " v-model="multiPreloadsCheck[
                                                        order.OrderID
                                                    ]
                                                        "></v-checkbox>
                                                <div v-if="
                                                    shift.DriverEleosApp ==
                                                    1
                                                ">
                                                    <div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-if="
                                                            order.UnknownOrigins !=
                                                            '' &&
                                                            order.UnknownOrigins !=
                                                            null
                                                        ">
                                                            <v-tooltip right>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="#2980B9" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-help-circle
                                                                    </v-icon>
                                                                </template>
                                                                <span>This load
                                                                    currently
                                                                    belongs to
                                                                    another
                                                                    Shift (in
                                                                    Eleos App):
                                                                    {{
                                                                        order.UnknownOrigins
                                                                    }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-else-if="
                                                            order.OrdLoadStatus ==
                                                            'READYTOSEND' ||
                                                            order.OrdLoadStatus ==
                                                            null
                                                        ">
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="orange darken-2" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-clock-check-outline
                                                                    </v-icon>
                                                                </template>
                                                                <span>Ready To
                                                                    Send</span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-else-if="
                                                            order.OrdLoadStatus ==
                                                            'DONE'
                                                        ">
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="green darken-2" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-check-circle-outline
                                                                    </v-icon>
                                                                </template>
                                                                <span>
                                                                    {{
                                                                        order.BOLNumber !=
                                                                            null
                                                                            ? 'Done' +
                                                                            ' / ' +
                                                                            'BOL#: ' +
                                                                            order.BOLNumber
                                                                            : 'Done'
                                                                    }}
                                                                </span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-else-if="
                                                            order.OrdLoadStatus ==
                                                            'INPROGRESS'
                                                        ">
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="blue darken-2" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-progress-clock
                                                                    </v-icon>
                                                                </template>
                                                                <span>
                                                                    {{
                                                                        order.BOLNumber !=
                                                                            null
                                                                            ? 'In Progress' +
                                                                            ' / ' +
                                                                            'BOL#: ' +
                                                                            order.BOLNumber
                                                                            : 'In Progress'
                                                                    }}
                                                                </span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-else-if="
                                                            order.OrdLoadStatus ==
                                                            'FORCEDCOMPLETION'
                                                        ">
                                                            <v-tooltip right>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="teal darken-2" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-alert-circle-check
                                                                    </v-icon>
                                                                </template>
                                                                <span>
                                                                    {{
                                                                        order.ReasonForChange !=
                                                                            null
                                                                            ? 'Forced Completion' +
                                                                            ' / ' +
                                                                            'By: ' +
                                                                            order.ChangeMadeBy +
                                                                            ' / ' +
                                                                            'Reasons: ' +
                                                                            order.ReasonForChange
                                                                            : 'Forced Completion'
                                                                    }}
                                                                </span>
                                                            </v-tooltip>
                                                        </div>
                                                        <div class="shifts5" style="margin-right: 10px;" v-else-if="
                                                            order.OrdLoadStatus ==
                                                            'NOTSTARTED'
                                                        ">
                                                            <v-tooltip left>
                                                                <template v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }">
                                                                    <v-icon color="gray darken-2" v-bind="attrs
                                                                        " v-on="on
                                                                            ">
                                                                        mdi-dots-horizontal-circle-outline
                                                                    </v-icon>
                                                                </template>
                                                                <span>Not
                                                                    Started</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="shifts5">
                                                    {{ order.LoadNum }}
                                                </div>
                                                <div class="shifts5">
                                                    {{ order.LoadNumOrd }}
                                                </div>
                                                <div class="shifts10">
                                                    {{ order.OrderID }}
                                                </div>
                                                <div class="shifts5">
                                                    <v-menu :close-on-content-click="false
                                                        " :nudge-width="200" offset-x>
                                                        <template v-slot:activator="{
                                                            on,
                                                            attrs
                                                        }">
                                                            <v-icon v-bind="attrs" v-on="on" :color="order.TerminalColor
                                                                " @click="
                                                                    showOrderDetails(
                                                                        order.OrderID
                                                                    )
                                                                    ">
                                                                mdi-circle
                                                            </v-icon>
                                                        </template>
                                                        <v-simple-table dense>
                                                            <thead>
                                                                <tr>
                                                                    <th>
                                                                        Product
                                                                    </th>
                                                                    <th>
                                                                        Product
                                                                        Code
                                                                    </th>
                                                                    <th>
                                                                        Quantity
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(prd,
                                                                    idx) in orderDetArr" v-bind:key="idx
                                                                        ">
                                                                    <td>
                                                                        {{
                                                                            prd.Product
                                                                        }}
                                                                    </td>
                                                                    <td>
                                                                        {{
                                                                            prd.ProductCode
                                                                        }}
                                                                    </td>
                                                                    <td>
                                                                        {{
                                                                            prd.DispatchedQuantity
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-simple-table>
                                                    </v-menu>
                                                </div>
                                                <div class="shifts20">
                                                    {{ order.Terminal }}
                                                </div>

                                                <v-alert class="shifts25 my-auto mx-1" v-if="
                                                    order.dpColor == 'blue'
                                                " :color="order.dpColor" dense text style="font-size: 11px">
                                                    {{ order.Station }}
                                                </v-alert>
                                                <div class="shifts25 my-auto mx-1" v-else>
                                                    {{ order.Station }}
                                                </div>
                                                <div class="shifts15">
                                                    {{ order.StationCity }}
                                                </div>
                                                <div class="shifts5">
                                                    {{ order.ROHrs }}
                                                </div>
                                                <div class="shifts5">
                                                    {{ order.GoalPost }}
                                                </div>
                                                <div v-if="
                                                    order.OrderStatus ==
                                                    'PRLDISPAT'
                                                ">
                                                    <v-icon color="green" small dense>mdi-square</v-icon>PRD
                                                </div>
                                                <div v-if="
                                                    order.OrderStatus ==
                                                    'PRELOAD'
                                                ">
                                                    <v-icon color="orange" small dense>mdi-square</v-icon>PRE
                                                </div>
                                            </v-list-item>
                                        </div>
                                    </draggable>
                                </v-list>
                                <div v-else class="spinner">
                                    <div class="sk-chase">
                                        <div class="sk-chase-dot"></div>
                                        <div class="sk-chase-dot"></div>
                                        <div class="sk-chase-dot"></div>
                                        <div class="sk-chase-dot"></div>
                                        <div class="sk-chase-dot"></div>
                                        <div class="sk-chase-dot"></div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </template>
                    <v-menu v-if="isContextMenuOpen" v-model="isContextMenuOpen" :position-x="menuPosition.x"
                        :position-y="menuPosition.y">
                        <!-- <v-list>
                            <v-list-item v-for="(qlf,idx) in driversBadge" v-bind:key="'qualifcation'+idx">
                                        <div style="margin-left:10px; width: 50%;" >{{ qlf.Driver }}</div>
                                        <div style="margin-left:10px; width: 30%;" >{{ qlf.ShiftStartTime }}</div >
                                        <div style="margin-left:10px; width: 5%;" ><v-icon >mdi-{{ qlf.Badge == true ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon></div >
                                        <div style="margin-left:10px; width: 5%;" ><v-icon >mdi-{{ qlf.QuandCall == true ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon></div >
                                        <div style="margin-left:10px; width: 5%;" ><v-icon >mdi-{{ qlf.PumpCall == true ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon></div >
                                        <div style="margin-left:10px; width: 5%;" ><v-icon >mdi-{{ qlf.YardCheck == true ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon></div >
                            </v-list-item>
                        </v-list> -->
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th>Driver</th>
                                    <th>Truck</th>
                                    <th>Trailer</th>
                                    <th>Yard</th>
                                    <th>StartTime</th>
                                    <th>NewAvialable</th>
                                    <th>HrsAviable</th>
                                    <th>Badge</th>
                                    <!-- <th>QuadCall</th>
                                    <th>PumpCall</th> -->
                                    <!-- <th>YardCheck</th>
                                    <th>Product</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(qlf, idx) in driversBadge" v-bind:key="'qualifcation' + idx">
                                    <td @click="
                                        scrollToElement(qlf.ShiftDetail)
                                        ">
                                        {{ qlf.Driver }}
                                    </td>
                                    <td>{{ qlf.Truck }}</td>
                                    <td>{{ qlf.Trailer }}</td>
                                    <td>{{ qlf.Yard }}</td>
                                    <td>{{ qlf.ShiftStartTime }}</td>
                                    <td>{{ qlf.NewAvialable }}</td>
                                    <td>
                                        {{ qlf.HrsAviable }}/{{
                                            qlf.TargetHours
                                        }}
                                    </td>

                                    <td>
                                        <v-icon :color="qlf.Badge == true
                                            ? 'success'
                                            : ''
                                            ">mdi-check-circle-outline</v-icon>
                                    </td>
                                    <!-- <td>
                                        <v-icon v-if="qlf.QuandCall == 1 && qlf.qualStQuad == 1" color="success">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else>mdi-check-circle-outline</v-icon>
                                    </td>
                                    <td>
                                        <v-icon v-if="qlf.PumpCall == 1 && qlf.qualStPump == 1" color="success">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else>mdi-check-circle-outline</v-icon>
                                    </td> -->
                                    <!-- <td><v-icon >mdi-{{ qlf.Badge == true ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon></td>
                                    <td><v-icon >mdi-{{ qlf.QuandCall == true ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon></td>
                                    <td><v-icon >mdi-{{ qlf.PumpCall == true ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon></td> -->
                                    <!-- <td><v-icon >mdi-{{ qlf.YardCheck == true ? 'check-circle-outline' : 'close-circle-outline' }}</v-icon></td> -->
                                    <!-- <td></td> -->
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-menu>
                    <vue-context ref="menu">
                        <template slot-scope="selectedOrder" v-if="selectedOrder.data">
                            <li>
                                <a @click="
                                    openModal(selectedOrder.data, 'shift')
                                    ">
                                    View Order
                                </a>
                            </li>
                            <!--<li>
                                <a @click="
                                    showProductCompartments(selectedOrder.data)
                                    ">Show Product Compartments</a>
                            </li>-->
                            <li v-if="
                                selectedOrder.data.OrdLoadStatus ==
                                'INPROGRESS' ||
                                selectedOrder.data.OrdLoadStatus ==
                                'DONE'
                            ">
                                <a @click="
                                    showBOLQuantities(selectedOrder.data)
                                    ">
                                    Show BOL Quantities
                                </a>
                            </li>
                            <li v-if="
                                selectedOrder.data.OrdLoadStatus ==
                                'INPROGRESS' ||
                                selectedOrder.data.OrdLoadStatus ==
                                'DONE'
                            ">
                                <a @click="showPaperwork(selectedOrder.data)">
                                    Show Paperwork
                                </a>
                            </li>
                            <li v-if="
                                selectedOrder.data.DriverEleosApp != 1
                                    ? true
                                    : selectedOrder.data.FinalizeOrder !=
                                        1 &&
                                        selectedOrder.data.OrderStatus ==
                                        'DISPATCHED'
                                        ? true
                                        : false
                            ">
                                <a @click.prevent="
                                    preloadOrder(selectedOrder.data)
                                    ">
                                    Preload Order to Line Up
                                </a>
                            </li>
                            <!-- <li>
                                <a

                                    @click.prevent="
                                        preloadOrderToShiftActive(selectedOrder.data)
                                    "
                                    >Preload Order to Shift</a
                                >
                            </li> -->
                            <li v-if="
                                selectedOrder.data.DriverEleosApp != 1
                                    ? true
                                    : selectedOrder.data.FinalizeOrder !=
                                        1 &&
                                        selectedOrder.data.OrderStatus ==
                                        'PRELOAD'
                                        ? true
                                        : false
                            ">
                                <a @click.prevent="
                                    unpreloadOrder(selectedOrder.data)
                                    ">
                                    Un-preload Order
                                </a>
                            </li>
                            <li v-if="
                                selectedOrder.data.DriverEleosApp != 1
                                    ? true
                                    : selectedOrder.data.FinalizeOrder != 1
                                        ? true
                                        : false
                            ">
                                <a @click.prevent="
                                    openModalSplit(selectedOrder.data)
                                    ">
                                    Split Order
                                </a>
                            </li>
                            <li v-if="
                                selectedOrder.data.DriverEleosApp != 1
                                    ? true
                                    : selectedOrder.data.FinalizeOrder != 1
                                        ? true
                                        : false
                            ">
                                <a @click.prevent="
                                    unsplitOrder(selectedOrder.data)
                                    ">
                                    Un-split Order
                                </a>
                            </li>
                        </template>
                    </vue-context>

                    <vue-context ref="menuMulti">
                        <template>
                            <li>
                                <a href="#" @click.prevent="
                                    multiPreloadOrder(multiPreloadsCheck)
                                    ">
                                    Multi-Preload Orders to Shift
                                </a>
                            </li>
                        </template>
                    </vue-context>

                    <vue-context ref="lineUpMenu">
                        <template slot-scope="selectedOrder" v-if="selectedOrder.data">
                            <v-list dense>
                                <v-subheader>{{selectedOrder.data.OrderID}}</v-subheader>
                                <v-list-item @mouseleave="hoveGroup = false" @click="
                                        openModal(selectedOrder.data, 'line-up')">
                                    <v-list-item-icon>
                                    <v-icon>mdi-file-eye</v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-title>View Order</v-list-item-title>
                                </v-list-item>
                                <v-list-group  @mouseenter="hoveGroup = true" :value="hoveGroup">
                                    <template v-slot:activator>
                                        <v-list-item-icon>
                                            <v-icon>mdi-gauge</v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Max Finalizer Driver
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                    <v-list-item v-for="subItem in selectedOrder.data.Drives" :key="subItem.id" exact @click="scrollToByDriver(subItem.id)">
                                        <v-list-item-icon>
                                            <v-icon v-text="'mdi-account-star'"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="subItem.Driver"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-group>
                            </v-list>
                        </template>
                    </vue-context>
                </v-row>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-dialog v-model="split_dialog" persistent max-width="500px">
                <v-card>
                    <v-form ref="form" lazy-validation>
                        <v-col>
                            <v-combobox v-model="split_type" :items="split_types" :item-text="'SplitTypeName'"
                                :item-value="'SplitTypeID'" label="Split Type" class="mx-3" required
                                :rules="[v => !!v || 'Split Type is required']" auto-select-first></v-combobox>
                        </v-col>
                        <v-btn color="secondary" text @click="
                            split_dialog = false;
                        unsplitOrder(splitOrderID);
                        ">Close</v-btn>
                        <v-btn color="green darken-1" text @click="validate()">Submit</v-btn>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog v-model="currentShiftForTheDriver" hide-overlay persistent max-width="600px"
                transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title>
                        <p style="margin: 0 auto;">Current Shift</p>
                    </v-card-title>

                    <v-alert text dense color="black" icon="mdi-account-alert" border="left"
                        style="margin: 0;padding-left: 30px;">
                        <p style="margin: 0;">
                            <strong>{{
                                currentShiftData[0].DriverName
                            }}</strong>
                        </p>
                        <p style="margin: 0;">
                            currently has a Shift in progress or not completed.
                        </p>
                        <p style="margin: 0;">
                            From the Date:
                            <strong>{{ currentShiftData[0].Date }}
                                {{ currentShiftData[0].Shift }}</strong>.
                        </p>
                        <p style="margin: 0;">
                            From the ShiftDetail:
                            <strong>{{
                                currentShiftData[0].ShiftDetail
                            }}</strong>.
                        </p>
                    </v-alert>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="black" text @click="currentShiftForTheDriver = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog v-model="currentShiftForTheTruck" hide-overlay persistent max-width="600px"
                transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title>
                        <p style="margin: 0 auto;">Current Truck</p>
                    </v-card-title>

                    <v-alert text dense color="#872A2A" icon="mdi-truck-alert-outline" border="left"
                        style="margin: 0;padding-left: 30px;">
                        <p style="margin: 0;">
                            <strong>{{ currentTruckData.DriverName }}</strong>
                        </p>
                        <p style="margin: 0;">
                            currently has a Shift in progress or not completed
                        </p>
                        <p style="margin: 0;">
                            using the Truck
                            <strong>{{ currentTruckData.TruckName }}</strong>
                        </p>
                        <p style="margin: 0;">
                            From the Date:
                            <strong>{{ currentTruckData.Date }}
                                {{ currentTruckData.Shift }}</strong>.
                        </p>
                        <p style="margin: 0;">
                            From the ShiftDetail:
                            <strong>{{ currentTruckData.ShiftDetail }}</strong>.
                        </p>
                    </v-alert>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#872A2A" text @click="currentShiftForTheTruck = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog v-model="showBOLDataByOrder" hide-overlay persistent max-width="600px"
                transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title>
                        <p style="margin: 0 auto;">BOL Quantities</p>
                    </v-card-title>

                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Product
                                    </th>
                                    <th class="text-left">
                                        Product Code
                                    </th>
                                    <th class="text-left">
                                        BOL Number
                                    </th>
                                    <th class="text-left">
                                        Dispatched Quantity
                                    </th>
                                    <th class="text-left">
                                        Gross Quantity
                                    </th>
                                    <th class="text-left">
                                        Net Quantity
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="prd in bolData" :key="prd.BolID">
                                    <td>{{ prd.Product }}</td>
                                    <td>{{ prd.ProductCode }}</td>
                                    <td>{{ prd.BOLNumber }}</td>
                                    <td>{{ prd.DispatchedQuantity }}</td>
                                    <td>{{ prd.GrossQuantity }}</td>
                                    <td>{{ prd.NetQuantity }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="showBOLDataByOrder = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog v-model="showPaperworkByOrder" hide-overlay persistent max-width="400px"
                transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title>
                        <p style="margin: 0 auto;">Order Paperwork</p>
                    </v-card-title>

                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        Document Type
                                    </th>
                                    <th class="text-center">
                                        Link
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="doc in paperworkData" :key="doc.DocumentID">
                                    <td class="text-center">
                                        {{ doc.DocumentType }}
                                    </td>
                                    <td class="text-center">
                                        <a :href="doc.Link" target="_blank">Show document</a>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="showPaperworkByOrder = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <OrdersForm v-if="$store.state.order.add" :back="true" />
        <edtOrder ref="ordersref" isModal="true" @close="onEditOrderClose" v-if="$store.state.order.edt" />
        <adviceDlg v-if="$store.state.dispatch.adviceDlg" :text="adviceText" :order="orderN"></adviceDlg>
        <v-dialog v-model="$store.state.dispatch.canvas" width="1300">
            <trailerView v-if="$store.state.dispatch.canvas"></trailerView>
        </v-dialog>

        <v-dialog v-model="$store.state.dispatch.potoshift" width="1300">
            <PreloadOrderToShift v-if="$store.state.dispatch.potoshift" :shiftHeaders="shift_headers"
                :orderRequired="ordersToShiftRequired" @close="onPreloadOrderToShiftClose"></PreloadOrderToShift>
        </v-dialog>

        <v-dialog v-model="commentDialog" width="1300">
            <v-card>
                <v-card-title class="text-h5 secondary white--text lighten-2">
                    <span class="mr-1" v-if="commentType == 'header'">
                        {{ header.ShiftDate }}</span>
                    Shift
                    <span class="ml-1 mr-1" v-if="commentType == 'shift'">
                        {{ shift.ShiftDetail }}</span>
                    - Comment
                </v-card-title>

                <v-card-text class="pt-5">
                    <div v-if="commentType == 'shift'" class="mx-4 mt-4">
                        <v-row>
                            <v-col>
                                <v-row>
                                    <h2>Date</h2>
                                </v-row>
                                <v-row class="mb-4 text-md-body-1">
                                    {{ shift.ShiftDate }}
                                </v-row>
                                <v-row>
                                    <h2>Driver</h2>
                                </v-row>
                                <v-row class="mb-4 text-md-body-1">
                                    {{ shift.Driver }}
                                </v-row>
                            </v-col>
                            <v-col>
                                <v-row>
                                    <h2>Truck</h2>
                                </v-row>
                                <v-row class="mb-4 text-md-body-1">
                                    {{ shift.Truck }}
                                </v-row>
                                <v-row>
                                    <h2>Trailer</h2>
                                </v-row>
                                <v-row class="mb-4 text-md-body-1">
                                    {{ shift.Trailer }}
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                    <v-textarea label="Comment" v-model="comment"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="danger" @click="commentDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" @click="saveComment()">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dispatchReports.Show" persistent max-width="900px">
            <v-card>
                <v-card-title style="margin-bottom: 17px;">
                    Dispatch Reports
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="3">
                            <v-select :items="dispatchReports.ReportList" label="Select a report" outlined
                                item-text="name" item-value="value" v-model="dispatchReports.SelectedReport" dense
                                hide-details return-object></v-select>
                        </v-col>
                        <v-col cols="3">
                            <v-combobox v-model="dispatchReports.Params.Customer" :items="dispatchReports.CustomerList"
                                item-text="Name" item-value="id" label="Select a customer" dense
                                hide-details></v-combobox>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field label="Start Date" v-model="dispatchReports.Params.StartDate" class="mr-2"
                                placeholder="YYYY-MM-DD" v-mask="'####-##-##'" dense hide-details></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field label="End Date" v-model="dispatchReports.Params.EndDate" class="ml-2"
                                placeholder="YYYY-MM-DD" v-mask="'####-##-##'" dense hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="getDispatchReportBySelect">
                        Get Report
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dispatchReports.Show = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>

        <ShiftSummary v-if="$store.state.dispatch.shiftSummary" :ShiftDetail="shDetail" :EmailCounter="emailCounter"
            :NewShiftInfo="newShiftInfo" @close="onShiftSummaryClose(shDetail)"></ShiftSummary>

        <FinalizeCurrentOrderInProgress v-if="$store.state.dispatch.finalizeCurrentOrderInProgress"
            :OrdersToBeEvaluated="ordersToBeEvaluated" :ShiftForcedCompletion="shiftForcedCompletion" @close="
                onFinalizeCurrentOrderInProgressClose(shiftForcedCompletion)
                "></FinalizeCurrentOrderInProgress>

        <UnknownOrigins v-if="$store.state.dispatch.unknownOrigins" :UnknownOrigins="unknownOrgn"></UnknownOrigins>
        <SynchronizationWarning v-if="$store.state.dispatch.syncWarning" :Message="syncMessage">
        </SynchronizationWarning>

        <ConfirmWindow v-if="$store.state.dispatch.confirmWindow" :Title="cwTitle" :Message="cwMessage"
            :ConfirmText="cwConfirmText" :Type="cwType" :ShiftDispatchFinalize="shiftDispatchFinalize"
            @close="onConfirmWindowClose"></ConfirmWindow>

        <ProductCompartments v-if="$store.state.dispatch.productCompartments" :ProductDistribution="productDistribution"
            :TotalsPrdDist="totalsPrdDist" :GroupedProducts="groupProducts" :CurrentReadings="currentReadings"
            @close="onProductCompartmentsClose"></ProductCompartments>
        <lastEta v-if="$store.state.dispatch.lastETA" :Truck="TruckETA"></lastEta>
        <Qualifications v-if="$store.state.dispatch.qualifications" :order="order" :ShiftHeaderNum="header.ShiftId">
        </Qualifications>
    </v-container>
</template>


<script>
import axios from 'axios';
import moment from 'moment';
import draggable from 'vuedraggable';
import VueContext from 'vue-context';
import _ from 'lodash';
import { mask } from 'vue-the-mask';
import Qualifications from '../../components/Modals/Dispatch/Dispatch/Qualifications.vue';
// import $ from 'jquery';

import OrdersForm from '../../components/Modals/Dispatch/Orders/AddOrder.vue';
import edtOrder from '../../components/Modals/Dispatch/Orders/EditOrder.vue';
import trailerView from '../../components/Modals/Dispatch/Dispatch/trailerView.vue';
import ShiftSummary from '../../components/Modals/Dispatch/Dispatch/ShiftSummary.vue';
import ConfirmDialogue from '../../components/Modals/ConfirmDialogue.vue';
import adviceDlg from '../../components/Modals/Dispatch/Advice/Advice.vue';
import PreloadOrderToShift from '../../components/Modals/Dispatch/Dispatch/PreloadOrderToShift.vue';
import lastEta from '../../components/Modals/Dispatch/Dispatch/LastETA.vue';
import FinalizeCurrentOrderInProgress from '../../components/Modals/Dispatch/Dispatch/FinalizeCurrentOrderInProgress.vue';
import UnknownOrigins from '../../components/Modals/Dispatch/Dispatch/UnknownOrigins.vue';
import SynchronizationWarning from '../../components/Modals/Dispatch/Dispatch/SynchronizationWarning.vue';
import ConfirmWindow from '../../components/Modals/Dispatch/Dispatch/ConfirmWindow.vue';
import ProductCompartments from '../../components/Modals/Dispatch/Dispatch/ProductCompartments.vue';

export default {
    name: 'DispatchSandbox',
    directives: { mask },
    components: {
        Qualifications,
        draggable,
        VueContext,
        OrdersForm,
        trailerView,
        edtOrder,
        ConfirmDialogue,
        adviceDlg,
        PreloadOrderToShift,
        lastEta,
        ShiftSummary,
        FinalizeCurrentOrderInProgress,
        UnknownOrigins,
        SynchronizationWarning,
        ConfirmWindow,
        ProductCompartments
    },
    data: function () {
        return {
            hoveGroup:false,
            block: false,
            order: [],
            isContextMenuOpen: false,
            orderDetArr: [],
            menuPosition: { x: 0, y: 0 },
            retain: [],
            Interplant: [],
            private: [],
            valid: true,
            changeOrd: 0,
            idxAdd: 0,
            idxRemv: 0,
            toLine: 0,
            toOrder: 0,
            idxChange: null,
            idxAddCopy: null,
            idxRemvCopy: null,
            shDetail: null,
            pdfDialog: false,
            arrStations: [],
            adviceText: '',
            urlPdf: '',
            radioGroup: '',
            width: '7',
            header: null,
            drivers: [],
            shift_headers: [],
            filteredYards: [],
            limitBy: '',
            generic: false,
            filterByItems: [
                '',
                'OrderID',
                'Terminal',
                'Station',
                'City',
                '48 Hrs',
                '24 Hrs',
                '12 Hrs'
            ],
            filterBySupplies: false,
            orders: [],
            shiftOrders: [],
            shiftDetails: [],
            shifts: [],
            driverBadges: [],
            yards: [],
            split_types: null,
            dispatchCols: 8,
            shiftCols: 6,
            search: '',
            tempSearch: '',
            editedIndex: null,
            addedOrder: false,
            changedOrder: false,
            dataLoading: true,
            shiftLoading: false,
            split_dialog: false,
            split_type: '',
            splitOrderID: 0,
            color: null,
            commentDialog: false,
            comment: null,
            commentType: null,
            headerComment: null,
            multiPreloads: {},
            ColorMultiPreloadBtn: '#4f83cc',
            ColorSTDBtn: '#4f83cc',
            AlterOrders: false,
            multiPreloadsCheck: {},
            TruckETA: null,
            shift: [],
            hoverShift: null,
            ordersToShiftRequired: [],
            shiftOrdersToPreload: [],
            reportTitles: [
                { title: 'Get Dispatch Report' },
                { title: 'Get No Allocation Report' }
            ],
            emailCounter: null,
            newShiftInfo: {},
            ordersToBeEvaluated: [],
            eleosMode: null,
            driversBadge: [],
            currentUsername: '',
            /*usersAuthorizedToChangeEleosMode: [
                'fchavarin',
                'amiranda',
                'hrodriguez',
                'parzate',
                'hcobian',
                //'piper',
                //'crodriguez',
                //'nguadiana',
                //'cmendoza',
                //'emaffi',
                //'dgarza'
            ],*/
            types: [
                { id: 0, Type: 'All' },
                { id: 1, Type: 'Contracted' },
                { id: 2, Type: 'Private' },
                { id: 3, Type: 'Interplant' }
            ],
            type: [],
            bolData: [],
            paperworkData: [],
            unknownOrgn: [],
            syncMessage: [],
            shiftForcedCompletion: null,
            shiftDispatchFinalize: null,
            cwTitle: null,
            cwMessage: null,
            cwConfirmText: null,
            cwType: null,
            currentShiftForTheDriver: false,
            currentShiftForTheTruck: false,
            showBOLDataByOrder: false,
            showPaperworkByOrder: false,
            currentShiftData: [
                {
                    Date: '',
                    DispatchFinalize: null,
                    DriverName: '',
                    Shift: '',
                    ShiftDetail: null
                }
            ],
            currentTruckData: {
                Date: '',
                DispatchFinalize: null,
                DriverName: '',
                Shift: '',
                ShiftDetail: null,
                TruckName: ''
            },
            productDistribution: [
                {
                    Comp: 'Comp1',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                },
                {
                    Comp: 'Comp2',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                },
                {
                    Comp: 'Comp3',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                },
                {
                    Comp: 'Comp4',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                },
                {
                    Comp: 'Comp5',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                },
                {
                    Comp: 'Comp6',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                }
            ],
            totalsPrdDist: {
                Totals: 'Totals',
                TotalVirtualCapacity: null,
                TotalCompCapacity: null,
                TotalPrdQty: null
            },
            currentQuantity: null,
            groupProducts: null,
            currentReadings: null,

            dispatchReports: {
                Show: false,
                ReportList: [
                    {
                        name: 'Load Tracking',
                        value: 'load-tracking',
                        endpoint: '/order/load-tracking',
                        export: true
                    }
                ],
                Params: {
                    StartDate: '',
                    EndDate: '',
                    Customer: null
                },
                SelectedReport: {},
                CustomerList: []
            }
        };
    },

    async mounted() {
        this.type = this.types[0];
        this.checkSize();
        this.loadShiftHeaders();
        this.loadSplitTypes();

        this.retrieveCurrentUser();
        this.loadCustomers();
    },
    computed: {
        filteredOrders: {
            get: function () {
                if (this.type.id == 1) {
                    return this.filteredOrdersFn(this.retain);
                } else if (this.type.id == 2) {
                    return this.filteredOrdersFn(this.private);
                } else if (this.type.id == 3) {
                    return this.filteredOrdersFn(this.Interplant);
                } else {
                    return this.filteredOrdersFn(this.orders);
                }
            },
            set: function (newValue) {
                if (!this.search) {
                    if (this.editedIndex != null) {
                        this.orders = newValue;
                        this.search = this.tempSearch;
                    }
                }
            }
        }
    },
    watch: {
        '$store.state.mini': function () {
            this.checkSize();
        },
        '$store.state.order.view': function () {
            if (this.$store.state.order.view == true) {
                this.$store.state.dialog = false;
                this.checkSize();
                this.$store.state.order.view = false;
            } else {
                console.log('test');
            }
        }
    },
    methods: {
        getDispatchReportBySelect: function() {
            console.log('getDispatchReportBySelect', this.dispatchReports);
            let str = this.$store;


            // Validate dates
            if (
                this.dispatchReports.Params.StartDate === '' ||
                this.dispatchReports.Params.EndDate === ''
            ) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'You must select a date range.'
                });
                return;
            }

            let params = {
                StartDate: this.dispatchReports.Params.StartDate,
                EndDate: this.dispatchReports.Params.EndDate,
                Export: this.dispatchReports.SelectedReport.export,
                Customer:
                    this.dispatchReports.Params.Customer !== null
                        ? this.dispatchReports.Params.Customer.id
                        : null
            };
            console.log(params);
            this.$store.state.isLoading = true;
            axios
                .post(this.dispatchReports.SelectedReport.endpoint, params, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const fileName =
                        this.dispatchReports.SelectedReport.name + '.xlsx';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                    this.dispatchReports.Show = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        loadCustomers: function () {
            axios
                .get('customer/active')
                .then(response => {
                    console.log(response.data.data);
                    this.dispatchReports.CustomerList = response.data.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        scrollToElement: function (elm) {
            console.log(elm);
            var element = document.getElementById(elm);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        scrollToByDriver: function (elm) {
            console.log(elm);
            var str =  this.$store;
            const searchDriver = this.shifts.findIndex(x => {
                return x.DriverID == elm;
            });
            if(searchDriver > 0){
                
            const shift = this.shifts[searchDriver];
                var element = document.getElementById(shift.ShiftDetail);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }else{
                str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Driver not found in this shift'
                    });
            }
        },
        verifyUsername: function () {
            let idx = this.usersAuthorizedToChangeEleosMode.indexOf(
                this.currentUsername
            );
            if (idx !== -1) {
                return true;
            } else {
                return false;
            }
        },
        async validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                await this.splitOrder(this.splitOrderID);
            }
        },
        retrieveCurrentUser: async function () {
            await axios
                .get('/current-user-name')
                .then(response => {
                    console.log(response.data);
                    this.currentUsername = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        dragOrder: function (evt) {
            console.log(evt);
        },
        moveOrder: function (evt) {
            //console.log("From moveOrder(evt)", evt);
            console.log('From: ', evt.from.id);
            console.log('To: ', evt.to.id);
        },
        generateGuid: function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                function (c) {
                    const r = (Math.random() * 16) | 0;
                    const v = c === 'x' ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                }
            );
        },
        onProductCompartmentsClose: function () {
            this.productDistribution = [
                {
                    Comp: 'Comp1',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                },
                {
                    Comp: 'Comp2',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                },
                {
                    Comp: 'Comp3',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                },
                {
                    Comp: 'Comp4',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                },
                {
                    Comp: 'Comp5',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                },
                {
                    Comp: 'Comp6',
                    Capacity: null,
                    VirtualCapacity: null,
                    Product: null,
                    ProductID: null,
                    Quantity: null,
                    Available: null
                }
            ];
            this.totalsPrdDist = {
                Totals: 'Totals',
                TotalVirtualCapacity: null,
                TotalCompCapacity: null,
                TotalPrdQty: null
            };
            this.currentQuantity = null;
            this.groupProducts = null;
            this.currentReadings = null;
        },
        checkPre: function (evt) {
            console.log('Here', evt, this.editedIndex);
            // if(idx[0].OrderStatus == "PRELOAD" || idx[0].OrderStatus == "PRLDISPAT"){
            //     this.block = true;
            // }else{
            //     this.block = false;
            // }
        },
        onConfirmWindowClose: function (type, shiftDetail, status) {
            let index = this.shiftDetails.indexOf(shiftDetail);
            switch (type) {
                case 'dispatchFinalize':
                    //let shiftData = await this.getSpecificShift(shDetail, index);
                    // Update DispatchFinalize locally
                    this.shifts[index].DispatchFinalize = status;
                    //this.loadShifts(true);
                    break;
                default:
                    console.log('No event on close.');
            }
        },
        onFinalizeCurrentOrderInProgressClose: function (shiftForcedCompletion) {
            console.log('Close Finalize Current Order In Progress');
            let index = this.shiftDetails.indexOf(shiftForcedCompletion);
            this.loadOrderShift(
                shiftForcedCompletion,
                index,
                'onFinalizeCurrentOrderInProgressClose'
            );
            //this.loadShifts(true);
        },
        onShiftSummaryClose: async function (shDetail) {
            console.log('Close Shift Summary', shDetail);
            let index = this.shiftDetails.indexOf(shDetail);
            this.setTrackingHours(shDetail);
            await this.loadOrderShift(shDetail, index, 'onShiftSummaryClose');
            // Update SentMailCounter locally
            let shiftData = await this.getSpecificShift(shDetail, index);
            this.shifts[index].SentMailCounter = shiftData.SentMailCounter;
            this.shifts[index].ColorSTDBtn = '#4f83cc';

            //this.loadShifts(true);
        },
        onEditOrderClose: async function (shDetail) {
            console.log(shDetail);
            let index = this.shiftDetails.indexOf(shDetail);
            let eleosCurrent = await this.checkForEleosCurrent(shDetail);

            await this.loadOrderShift(shDetail, index, 'onEditOrderClose');
            console.log(this.shifts[index].SentMailCounter);
            if (
                this.shifts[index].SentMailCounter > 0 &&
                this.shifts[index].DriverEleosApp == 1 &&
                eleosCurrent == 1
            ) {
                console.log('Dentro del if');
                let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                    shDetail,
                    index
                );
                await this.getCurrentShiftInfo(
                    shDetail,
                    index,
                    newShiftInfoDispatch
                );
            }
        },
        onPreloadOrderToShiftClose: async function (shiftDetailOrigin) {
            let index = this.shiftDetails.indexOf(shiftDetailOrigin);
            let eleosCurrent = await this.checkForEleosCurrent(
                shiftDetailOrigin
            );
            console.log('Cerrando Preload Order To Shift');
            await this.loadOrderShift(
                shiftDetailOrigin,
                index,
                'onPreloadOrderToShiftClose'
            );
            await this.updateActiveOrder(
                shiftDetailOrigin,
                index,
                'onPreloadOrderToShiftClose'
            );
            //this.loadShifts(true);
            if (
                this.shifts[index].SentMailCounter > 0 &&
                this.shifts[index].DriverEleosApp == 1 &&
                eleosCurrent == 1
            ) {
                console.log('Dentro del if');
                let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                    shiftDetailOrigin,
                    index
                );
                await this.getCurrentShiftInfo(
                    shiftDetailOrigin,
                    index,
                    newShiftInfoDispatch
                );
            }
        },
        openLastETA: function (Truck) {
            this.TruckETA = Truck;
            console.log(this.TruckETA);
            this.$store.state.dispatch.lastETA = true;
        },
        setTrackingHours: function (shDetail) {
            var str = this.$store;
            console.log('setTrackingHours', shDetail);
            axios
                .post('order/tracking-hours/update/' + shDetail, '')
                .then(response => {
                    console.log(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        getCurrentShiftInfo: async function (
            shDetail,
            index,
            newShiftInfoDispatch
        ) {
            let emailCounter = this.shifts[index].SentMailCounter;

            if (emailCounter > 0) {
                this.$store.state.isLoading = true;
                var str = this.$store;
                await axios
                    .get('shift-diff-checker/current-info/' + shDetail, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        let currentShiftInfoDispatch = response.data;
                        console.log(
                            'CurrentShiftInfoDispatch',
                            currentShiftInfoDispatch
                        );
                        this.$store.state.isLoading = false;
                        await this.getProductsByOrder(
                            emailCounter,
                            index,
                            newShiftInfoDispatch,
                            currentShiftInfoDispatch
                        );
                    })
                    .catch(function (error) {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                        this.$store.state.isLoading = false;
                    });
            } else {
                console.log(emailCounter);
                await this.getProductsByOrder(
                    emailCounter,
                    index,
                    newShiftInfoDispatch,
                    {}
                );
            }
        },
        getProductsByOrder: async function (
            emailCounter,
            index,
            newShiftInfoDispatch,
            currentShiftInfoDispatch
        ) {
            var str = this.$store;

            console.log('Dentro de getProductsByOrder', newShiftInfoDispatch);
            for (let ord of newShiftInfoDispatch.ordersShiftData) {
                //console.log(ord.generalOrderData.OrderID)

                await axios
                    .get('order-detail/order/' + ord.generalOrderData.OrderID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        let productsByOrder = response.data.data;
                        console.log('productsByOrder', productsByOrder);
                        ord.orderProductData = [];
                        for (let prd of productsByOrder) {
                            let {
                                Product,
                                ProductID,
                                ProductCode,
                                DispatchedQuantity
                            } = prd;
                            ord.orderProductData.push({
                                Product,
                                ProductID,
                                ProductCode,
                                DispatchedQuantity
                            });
                        }

                        // Ordenamiento tipo burbuja por ProductID
                        let l = ord.orderProductData.length;
                        let aux;

                        for (let i = 1; i < l; i++) {
                            for (let prd = 0; prd < l - i; prd++) {
                                if (
                                    ord.orderProductData[prd].ProductID >
                                    ord.orderProductData[prd + 1].ProductID
                                ) {
                                    aux = ord.orderProductData[prd];
                                    ord.orderProductData[prd] =
                                        ord.orderProductData[prd + 1];
                                    ord.orderProductData[prd + 1] = aux;
                                }
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });
            }

            if (emailCounter > 0) {
                this.generateDiffs(
                    index,
                    newShiftInfoDispatch,
                    currentShiftInfoDispatch
                );
            } else {
                console.log('No se ha hecho el primer envío.');
            }
            console.log('NewShiftInfo', newShiftInfoDispatch);
        },
        buildNewShiftInfoDispatch: function (shDetail, index) {
            console.log(shDetail, index);
            let newShiftInfoDispatch = {};
            let shift = this.shifts[index];

            // Preparation of the new shift info data
            let {
                Driver,
                DriverID,
                ShiftDate,
                Shift,
                ShiftDetail,
                Truck,
                TruckID,
                Trailer,
                TrailerID,
                ReplacementUnit,
                Yard,
                TruckYard,
                SentMailCounter
            } = shift;

            let generalShiftData = {
                Driver,
                DriverID,
                ShiftDate,
                Shift,
                ShiftDetail,
                Truck,
                TruckID,
                Trailer,
                TrailerID,
                ReplacementUnit,
                Yard,
                TruckYard,
                SentMailCounter
            };

            console.log(shift);
            console.log(generalShiftData);

            newShiftInfoDispatch['generalShiftData'] = generalShiftData;
            newShiftInfoDispatch['ordersShiftData'] = [];

            for (let ord of this.shiftOrders[index]) {
                let {
                    Customer,
                    CustomerID,
                    Supplier,
                    SupplierID,
                    LoadNum,
                    LoadNumOrd,
                    LoadingNumber,
                    OrderID,
                    OrderStatus,
                    PreloadOrderID,
                    ShipTo,
                    SpecialInstructions,
                    StationID,
                    Station,
                    StationAddress,
                    StationCity,
                    TerminalID,
                    Terminal,
                    TerminalAddress,
                    TerminalColor
                } = ord;

                newShiftInfoDispatch['ordersShiftData'].push({
                    generalOrderData: {
                        Customer,
                        CustomerID,
                        Supplier,
                        SupplierID,
                        LoadNum,
                        LoadNumOrd,
                        LoadingNumber,
                        OrderID,
                        OrderStatus,
                        PreloadOrderID,
                        ShipTo,
                        SpecialInstructions,
                        StationID,
                        Station,
                        StationAddress,
                        StationCity,
                        TerminalID,
                        Terminal,
                        TerminalAddress,
                        TerminalColor
                    },
                    orderProductData: []
                });
            }

            return newShiftInfoDispatch;
        },
        generateDiffs: function (
            index,
            newShiftInfoDispatch,
            currentShiftInfoDispatch
        ) {
            // Current variables
            const currGenShData = currentShiftInfoDispatch.generalShiftData;
            const currOrdShData = currentShiftInfoDispatch.ordersShiftData;

            // New variables
            const newGenShData = newShiftInfoDispatch.generalShiftData;
            const newOrdShData = newShiftInfoDispatch.ordersShiftData;

            let matchingOrders = [];

            // Diffs at Shift Level
            let diffDriver = currGenShData.DriverID != newGenShData.DriverID;
            let diffTruck = currGenShData.TruckID != newGenShData.TruckID;
            let diffTrailer = currGenShData.TrailerID != newGenShData.TrailerID;
            let diffReplUnit =
                currGenShData.ReplacementUnit != newGenShData.ReplacementUnit;

            let thereAreDiffs =
                diffTruck || diffTrailer || diffReplUnit || diffDriver;

            // Diffs at Order Level
            for (let newOrd = 0; newOrd < newOrdShData.length; newOrd++) {
                for (
                    let currOrd = 0;
                    currOrd < currOrdShData.length;
                    currOrd++
                ) {
                    if (
                        newOrdShData[newOrd].generalOrderData.OrderID ==
                        currOrdShData[currOrd].generalOrderData.OrderID
                    ) {
                        let newOrderData =
                            newOrdShData[newOrd].generalOrderData;
                        let currOrderData =
                            currOrdShData[currOrd].generalOrderData;

                        let newPrdData = newOrdShData[newOrd].orderProductData;
                        let currPrdData =
                            currOrdShData[currOrd].orderProductData;

                        newOrdShData[newOrd].MatchingProductData = [];
                        newOrdShData[newOrd].OnlyNewProductData = [];

                        // Order Diffs
                        newOrderData.orderDiffs = {};
                        newOrderData.orderDiffs.diffLoadNum =
                            newOrderData.LoadNum != currOrderData.LoadNum;
                        newOrderData.orderDiffs.diffLoadNumOrd =
                            newOrderData.LoadNumOrd != currOrderData.LoadNumOrd;
                        newOrderData.orderDiffs.diffPreloaded =
                            newOrderData.OrderStatus !=
                            currOrderData.OrderStatus;
                        newOrderData.orderDiffs.diffTerminal =
                            newOrderData.TerminalID != currOrderData.TerminalID;
                        newOrderData.orderDiffs.diffStation =
                            newOrderData.StationID != currOrderData.StationID;
                        newOrderData.orderDiffs.diffCustomer =
                            newOrderData.CustomerID != currOrderData.CustomerID;
                        newOrderData.orderDiffs.diffSupplier =
                            newOrderData.SupplierID != currOrderData.SupplierID;
                        newOrderData.orderDiffs.diffLoadingNumber =
                            newOrderData.LoadingNumber !=
                            currOrderData.LoadingNumber;
                        newOrderData.orderDiffs.diffShipTo =
                            newOrderData.ShipTo != currOrderData.ShipTo;
                        newOrderData.orderDiffs.diffSpecialInstructions =
                            newOrderData.SpecialInstructions !=
                            currOrderData.SpecialInstructions;
                        newOrderData.orderDiffs.hasDiffs =
                            newOrderData.orderDiffs.diffLoadNum ||
                            newOrderData.orderDiffs.diffLoadNumOrd ||
                            newOrderData.orderDiffs.diffPreloaded ||
                            newOrderData.orderDiffs.diffTerminal ||
                            newOrderData.orderDiffs.diffStation ||
                            newOrderData.orderDiffs.diffCustomer ||
                            newOrderData.orderDiffs.diffSupplier ||
                            newOrderData.orderDiffs.diffLoadingNumber ||
                            newOrderData.orderDiffs.diffShipTo ||
                            newOrderData.orderDiffs.diffSpecialInstructions;
                        newOrderData.orderDiffs.hasPrdDiffs = false;
                        if (!thereAreDiffs) {
                            thereAreDiffs = newOrderData.orderDiffs.hasDiffs;
                        }

                        // Product Diffs
                        for (
                            let newPrd = 0;
                            newPrd < newPrdData.length;
                            newPrd++
                        ) {
                            for (
                                let currPrd = 0;
                                currPrd < currPrdData.length;
                                currPrd++
                            ) {
                                if (
                                    newPrdData[newPrd].ProductID ==
                                    currPrdData[currPrd].ProductID &&
                                    newPrdData[newPrd].ProductCode ==
                                    currPrdData[currPrd].ProductCode &&
                                    newPrdData[newPrd].Product ==
                                    currPrdData[currPrd].Product
                                ) {
                                    currPrdData[currPrd].IsMatch = true;
                                    newPrdData[newPrd].diffDispatchedQuantity =
                                        newPrdData[newPrd].DispatchedQuantity !=
                                        currPrdData[currPrd].DispatchedQuantity;
                                    if (!thereAreDiffs) {
                                        thereAreDiffs =
                                            newPrdData[newPrd]
                                                .diffDispatchedQuantity;
                                    }
                                    if (!newOrderData.orderDiffs.hasPrdDiffs) {
                                        newOrderData.orderDiffs.hasPrdDiffs =
                                            newPrdData[
                                                newPrd
                                            ].diffDispatchedQuantity;
                                    }
                                    newOrdShData[
                                        newOrd
                                    ].MatchingProductData.push({
                                        Current: currPrdData[currPrd],
                                        New: newPrdData[newPrd]
                                    });
                                    break;
                                }

                                if (currPrd == currPrdData.length - 1) {
                                    newOrdShData[
                                        newOrd
                                    ].OnlyNewProductData.push(
                                        newPrdData[newPrd]
                                    );
                                    newOrderData.orderDiffs.hasPrdDiffs = true;
                                    if (!thereAreDiffs) {
                                        thereAreDiffs = true;
                                    }
                                }
                            }
                        }

                        newOrdShData[
                            newOrd
                        ].OnlyCurrentProductData = currPrdData.filter(
                            prd => prd.IsMatch != true
                        );
                        if (
                            newOrdShData[newOrd].OnlyCurrentProductData
                                .length !== 0
                        ) {
                            newOrderData.orderDiffs.hasPrdDiffs = true;
                            if (!thereAreDiffs) {
                                thereAreDiffs = true;
                            }
                        }

                        //this.OrderData.push({ "Current":  currOrdShData[currOrd], "New": newOrdShData[newOrd] });
                        matchingOrders.push(
                            currOrdShData[currOrd].generalOrderData.OrderID
                        );
                        break;
                    }

                    if (currOrd == currOrdShData.length - 1) {
                        //this.OrderData.push({ "Current": false, "New":  newOrdShData[newOrd] });
                        if (!thereAreDiffs) {
                            thereAreDiffs = true;
                        }
                    }
                }
            }

            // Check that matchingOrders is empty
            if (matchingOrders.length == 0) {
                /*for (let ord of currOrdShData) {
                    this.OrderData.push({ "Current": ord, "New": false });
                }*/
                if (!thereAreDiffs) {
                    thereAreDiffs = true;
                }
            } else {
                for (let ord = 0; ord < currOrdShData.length; ord++) {
                    for (
                        let ordId = 0;
                        ordId < matchingOrders.length;
                        ordId++
                    ) {
                        if (
                            currOrdShData[ord].generalOrderData.OrderID ==
                            matchingOrders[ordId]
                        ) {
                            break;
                        } else if (ordId == matchingOrders.length - 1) {
                            //this.OrderData.push({ "Current": currOrdShData[ord], "New": false });
                            if (!thereAreDiffs) {
                                thereAreDiffs = true;
                            }
                        }
                    }
                }
            }

            if (thereAreDiffs) {
                this.shifts[index].ColorSTDBtn = '#ceb500';
            } else {
                this.shifts[index].ColorSTDBtn = '#4f83cc';
            }

            this.updatePendingRevises(index, thereAreDiffs);
        },
        updatePendingRevises: async function (index, thereAreDiffs) {
            console.log(thereAreDiffs);
            var str = this.$store;
            let shDetail = this.shiftDetails[index];
            let params = {
                ShiftDetail: shDetail,
                PendingRevises: thereAreDiffs ? 1 : 0
            };

            await axios
                .put('shift-detail/pending-revises', params)
                .then(async response => {
                    console.log(response.data);
                    //this.loadShifts(true);
                })
                .catch(function (error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        getOrdersByShiftDetail: async function (
            shiftDetail,
            index,
            dvrName,
            instruction
        ) {
            var str = this.$store;
            /*if (this.shiftOrders[index].length == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This Shift has no orders.'
                });
                return;
            }*/

            if (instruction == 'just-refresh') {
                str.dispatch('setSnackbar', {
                    color: '#1F618D',
                    text: 'Refreshing orders...'
                });
            } else if (instruction == 'synchronization') {
                if (dvrName !== '') {
                    this.syncMessage = [
                        `${dvrName}`,
                        ' has progressed in his Shift.',
                        'Your actions will not be executed.',
                        'Try it again after synchronization.',
                        'Synchronizing data with Eleos App...'
                    ];
                    this.$store.state.dispatch.syncWarning = true;

                    /*str.dispatch('setSnackbar', {
                        color: '#1F618D',
                        text: `${dvrName} has progressed in his Shift.\n\n
                               Your actions will not be executed.\n\n
                               Try it again after synchronization.\n\n
                               Synchronizing information...`
                    });*/
                }
            }

            this.shifts[index].View = false;
            this.shiftOrders[index].length = 0;
            await axios
                .get('order/shift/' + shiftDetail)
                .then(response => {
                    console.log(response.data);
                    this.shiftOrders[index] = response.data;
                    this.shifts[index].View = true;
                })
                .catch(function (error) {
                    console.log(error);
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        getDriverShiftByTerminaBadge: function (order) {
            var parms = {
                Terminal: order.TerminalID,
                Station: order.StationID,
                QuadCall: order.QuadCall,
                PumpCall: order.PumpCall,
                RateId: order.RateId,
                ShiftHeaderNum: this.header.ShiftId
            };
            var str = this.$store;

            console.log(event);
            this.menuPosition = { x: event.clientX, y: event.clientY };
            this.isContextMenuOpen = true;
            axios
                .post('driver-badge/qualifications', parms)
                .then(response => {
                    this.driversBadge = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        loadGenericStations: function () {
            this.$store.state.isLoading = true;
            axios
                .get('station/active')
                .then(response => {
                    this.genericStations = response.data.data.filter(
                        st => st.IsGeneric === 1
                    );
                    console.log(this.genericStations);
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        refreshTempPendingOrders: function () {
            this.$store.state.isLoading = true;

            var str = this.$store;
            str.dispatch('setSnackbar', {
                color: 'error',
                text:
                    'Sent update readings request, this process takes a few minutes.'
            });

            axios
                .get('/ftp-readings/update')
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Readings Update Complete, Refresh page'
                    });
                    console.log(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        groupingOrders: async function () {
            // console.log(this.generic)

            // let ordersWithRetailStations = [];
            // let ordersWithGenericStations = this.orders.filter(ord => {
            //     for (let genSt of this.genericStations) {
            //         if (genSt.id === ord.StationID) return ord;
            //     }
            // });

            // for (let ord of this.orders) {
            //     for (
            //         let ordGen = 0;
            //         ordGen < ordersWithGenericStations.length;
            //         ordGen++
            //     ) {
            //         if (
            //             ordersWithGenericStations[ordGen].OrderID !==
            //             ord.OrderID
            //         ) {
            //             if (ordGen === ordersWithGenericStations.length - 1) {
            //                 ordersWithRetailStations.push(ord);
            //             }
            //             continue;
            //         } else {
            //             break;
            //         }
            //     }
            // }
            console.log(this.retain);
            return this.retain;
            // return this.filteredOrdersFn(this.retain);
        },
        HrsSelect: function () {
            if (this.limitBy == '48 Hrs' || this.limitBy == '24 Hrs' || this.limitBy == '12 Hrs') {
                this.search = moment().format('YYYY-MM-DD');
            } else {
                this.search = '';
            }
        },
        filteredOrdersFn: function (ordersArr) {
            console.log(ordersArr);

            var date = moment().format('YYYY-MM-DD HH:mm');
            var hr12 = moment().format('YYYY-MM-DD HH:mm');
            var hr24 = moment().format('YYYY-MM-DD HH:mm');
            var hr48 = moment().format('YYYY-MM-DD HH:mm');

            var flt12 = moment(hr12).add(12, 'hours').format('YYYY-MM-DD HH:mm');
            var flt24 = moment(hr24).add(24, 'hours').format('YYYY-MM-DD HH:mm');
            var flt48 = moment(hr48).add(48, 'hours').format('YYYY-MM-DD HH:mm');
            // console.log(date, flt);
            return _.orderBy(
                ordersArr.filter(order => {
                    if (!this.search) return ordersArr;
                    if (this.limitBy != '') {
                        var $ftlr = '';
                        switch (this.limitBy) {
                            case 'OrderID':
                                $ftlr = order.OrderID.toString().includes(
                                    this.search.toLowerCase()
                                );
                                break;

                            case 'Terminal':
                                $ftlr = order.Terminal.toLowerCase().includes(
                                    this.search.toLowerCase()
                                );
                                break;

                            case 'Station':
                                $ftlr = order.Station.toLowerCase().includes(
                                    this.search.toLowerCase()
                                );
                                break;

                            case 'City':
                                $ftlr = order.StationCity.toLowerCase().includes(
                                    this.search.toLowerCase()
                                );
                                break;
                            case '48 Hrs':
                                $ftlr = order.DateRequested >= date && order.DateRequested <= flt48;
                                break;
                            case '24 Hrs':
                                $ftlr = order.DateRequested >= date && order.DateRequested <= flt24;
                                break;
                            case '12 Hrs':
                                $ftlr = order.DateRequested >= date && order.DateRequested <= flt12;
                                break;
                        }
                        return $ftlr;
                    } else {
                        if (order.OrderID != null) {
                            return order.OrderID.toString().includes(
                                this.search.toLowerCase()
                            );
                        }
                        if (this.radioGroup == 'Terminal') {
                            return order.Terminal.toString().includes(
                                this.search.toLowerCase()
                            );
                        }
                        if (this.radioGroup == 'Station') {
                            return order.Station.toString().includes(
                                this.search.toLowerCase()
                            );
                        }
                        if (this.radioGroup == 'StationCity') {
                            return order.StationCity.toString().includes(
                                this.search.toLowerCase()
                            );
                        }
                    }
                })
            );
        },
        validateShiftCompletion: async function (shift, index, action) {
            console.log(index, action);
            var str = this.$store;
            /*if (this.shiftOrders[index].length == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This Shift has no orders.'
                });
                return;
            }*/

            let shiftDetail = shift.ShiftDetail;
            let isSynchronized = await this.checkSyncPlatforms(
                shiftDetail,
                'not-apply',
                'tools'
            );
            if (isSynchronized) {
                for (let ord of this.shiftOrders[index]) {
                    if (ord.FinalizeOrder != 1) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This Shift has unfinished orders.'
                        });
                        return;
                    }
                }

                this.shiftDispatchFinalize = shift;
                this.cwTitle = action == 'open' ? 'Open Shift' : 'Close Shift';
                this.cwMessage =
                    'Are you sure you want to ' + action + ' this Shift?';
                this.cwConfirmText =
                    action == 'open' ? 'Open Shift' : 'Close Shift';
                this.cwType = 'dispatchFinalize';
                this.$store.state.dispatch.confirmWindow = true;
            }
        },
        checkQualifications: function (ord) {
            this.order = ord;
            this.$store.state.dispatch.qualifications = true;
        },
        checkDriversByTerminalBadge: async function (ord) {
            this.isContextMenuOpen = true;
            this.menuPosition = { x: event.clientX, y: event.clientY };
            // Get All DriverID from the list of the Shifts
            const driversSh = await this.shifts.map(x => {
                return x.DriverID;
            });
            // Get all Drivers from the list of the Badge
            var drivers = await this.driversBadge.filter(x => {
                return x.TerminalID == ord.TerminalID;
            });

            const filteredArray = drivers.filter(item =>
                driversSh.includes(item.DriverID)
            );

            console.log(filteredArray);
            this.drivers = filteredArray;
        },
        checkOriginOfLoadsInterface: async function (shift, index) {
            var str = this.$store;
            this.$store.state.isLoading = true;
            this.unknownOrgn = [];

            let data = {
                OrderIDs: [],
                ShiftDetail: shift.ShiftDetail
            };

            for (let ord of this.shiftOrders[index]) {
                data.OrderIDs.push(ord.OrderID);
            }

            // Consult all shift order origins
            let origins = {};
            await axios
                .post('shift-detail/order-origin', data, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(function (response) {
                    //console.log("response->", response.data);
                    origins = response.data;
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });

            console.log('Origins: ', origins);

            // Set the variable for unknown origins
            let unknownOrigins = {};

            // Finds unknown origins
            for (let ordID in origins) {
                if (origins[ordID].length == 0) {
                    continue;
                } else {
                    unknownOrigins[ordID] = [];
                    for (let origin of origins[ordID]) {
                        if (origin.ShiftDetail == shift.ShiftDetail) {
                            continue;
                        } else {
                            unknownOrigins[ordID].push({
                                ShiftDetail: origin.ShiftDetail,
                                DriverName: origin.DriverName,
                                Date: origin.Date + ' ' + origin.Shift
                            });
                        }
                    }
                }
            }

            // Control to show UnknownOrigins or not
            let showUnknownOrigins = false;

            // Verify and save unknown origins
            for (let ordID in unknownOrigins) {
                if (unknownOrigins[ordID].length == 0) {
                    continue;
                } else {
                    showUnknownOrigins = true;
                    for (let unk of unknownOrigins[ordID]) {
                        this.unknownOrgn.push({
                            OrderID: ordID,
                            ShiftDetail: unk.ShiftDetail,
                            DriverName: unk.DriverName,
                            Date: unk.Date
                        });
                    }
                }
            }

            if (showUnknownOrigins) {
                this.$store.state.dispatch.unknownOrigins = true;
            } else {
                this.confirmShiftSummary(shift, index);
            }
        },
        checkForCurrentTruck: async function (truckID) {
            var str = this.$store;
            this.$store.state.isLoading = true;
            let truckData = null;
            await axios
                .get('shift-detail/current-truck/' + truckID)
                .then(response => {
                    console.log(response.data);
                    truckData = response.data;
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
            return truckData;
        },
        checkForCurrentShift: async function (driverID) {
            var str = this.$store;
            this.$store.state.isLoading = true;
            let shiftData = null;
            await axios
                .get('shift-detail/current-shift/' + driverID)
                .then(response => {
                    console.log(response.data);
                    shiftData = response.data;
                    str.state.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                });
            return shiftData;
        },
        checkOriginOfLoads: async function (shift, index) {
            //var str = this.$store;
            /*if (this.shiftOrders[index].length == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This Shift has no orders.'
                });
                return;
            }*/

            if (shift.DriverEleosApp == 1) {
                let currShiftData = await this.checkForCurrentShift(
                    shift.DriverID
                );
                console.log(currShiftData);

                if (currShiftData.length != 0) {
                    if (
                        currShiftData[0].DispatchFinalize == 0 &&
                        currShiftData[0].ShiftDetail != shift.ShiftDetail
                    ) {
                        console.log(
                            'Dentro del if, abriendo currentShiftForTheDriver.'
                        );
                        this.currentShiftData = currShiftData;
                        this.currentShiftForTheDriver = true;
                        return;
                    } else {
                        console.log('This is the same Shift.');
                    }
                } else {
                    console.log(
                        'No hay ningún Shift actualmente en la tabla EleosCurrentLoadsByDriver.'
                    );
                }

                let currTruckData = await this.checkForCurrentTruck(
                    shift.TruckID
                );
                console.log(currTruckData);

                if (currTruckData.length != 0) {
                    for (let trk of currTruckData) {
                        if (
                            trk.DispatchFinalize == 0 &&
                            trk.ShiftDetail != shift.ShiftDetail
                        ) {
                            console.log(
                                'Dentro del if, abriendo currentShiftForTheTruck.'
                            );
                            this.currentTruckData = trk;
                            this.currentShiftForTheTruck = true;
                            return;
                        } else {
                            console.log('This is the same Shift.');
                        }
                    }
                } else {
                    console.log(
                        'No hay ningún Shift con ese Truck actualmente en la tabla EleosCurrentVehicleByDriver.'
                    );
                }

                let shiftDetail = shift.ShiftDetail;
                let isSynchronized = await this.checkSyncPlatforms(
                    shiftDetail,
                    'not-apply',
                    'tools'
                );
                if (isSynchronized) {
                    await this.checkOriginOfLoadsInterface(shift, index);
                }
            } else {
                await this.checkOriginOfLoadsInterface(shift, index);
            }
        },
        confirmShiftSummary: function (shift, index) {
            this.shDetail = null;
            this.emailCounter = null;
            this.newShiftInfo = {};

            this.shDetail = shift.ShiftDetail;
            this.emailCounter = shift.SentMailCounter;

            //console.log('Open Shift Summary', this.shDetail, shift);
            //this.$store.state.dispatch.mail = true;
            //console.log(this.shiftOrders[index]);

            // Preparation of the new shift info data

            let {
                Driver,
                DriverID,
                ShiftDate,
                Shift,
                ShiftDetail,
                Truck,
                TruckID,
                Trailer,
                TrailerID,
                ReplacementUnit,
                Yard,
                TruckYard,
                SentMailCounter,
                DriverEleosApp
            } = shift;

            let generalShiftData = {
                Driver,
                DriverID,
                ShiftDate,
                Shift,
                ShiftDetail,
                Truck,
                TruckID,
                Trailer,
                TrailerID,
                ReplacementUnit,
                Yard,
                TruckYard,
                SentMailCounter,
                DriverEleosApp
            };

            console.log(shift);
            console.log(generalShiftData);

            this.newShiftInfo['generalShiftData'] = generalShiftData;
            this.newShiftInfo['ordersShiftData'] = [];

            for (let ord of this.shiftOrders[index]) {
                let {
                    Customer,
                    CustomerID,
                    Supplier,
                    SupplierID,
                    LoadNum,
                    LoadNumOrd,
                    LoadingNumber,
                    OrderID,
                    OrderStatus,
                    PreloadOrderID,
                    ShipTo,
                    SpecialInstructions,
                    StationID,
                    Station,
                    StationAddress,
                    StationCity,
                    TerminalID,
                    Terminal,
                    TerminalAddress,
                    TerminalColor
                } = ord;

                this.newShiftInfo['ordersShiftData'].push({
                    generalOrderData: {
                        Customer,
                        CustomerID,
                        Supplier,
                        SupplierID,
                        LoadNum,
                        LoadNumOrd,
                        LoadingNumber,
                        OrderID,
                        OrderStatus,
                        PreloadOrderID,
                        ShipTo,
                        SpecialInstructions,
                        StationID,
                        Station,
                        StationAddress,
                        StationCity,
                        TerminalID,
                        Terminal,
                        TerminalAddress,
                        TerminalColor
                    },
                    orderProductData: []
                });
            }
            //console.log(this.newShiftInfo);

            this.$store.state.dispatch.shiftSummary = true;
        },
        log: function (msg) {
            console.log(msg);
        },
        openOrderForm: function () {
            this.$store.state.order.add = true;
            this.back = true;
            this.$store.state.editedOrder.id = null;
            this.$store.state.editedOrder.StationID = null;
            this.$store.state.editedOrder.destiny = 1;
        },
        chargeShift: async function () {
            var date = moment().format('YYYY-MM-DD') + ' ' + 'PM';
            const index = this.shift_headers.findIndex(elm => {
                return elm.ShiftDate == "2024-08-07 PM";
            });
            this.header = this.shift_headers[index];
            this.loadShifts(true);
        },
        async openModal(orderObj, origin) {
            let orderID = orderObj.OrderID;
            let index = this.shiftDetails.indexOf(orderObj.ShiftDetail);
            let shift = this.shifts[index];

            if (origin == 'shift') {
                if (shift.DriverEleosApp == 1) {
                    let shiftDetail = orderObj.ShiftDetail;
                    let isSynchronized = await this.checkSyncPlatforms(
                        shiftDetail,
                        'not-apply',
                        'view-order'
                    );
                    if (isSynchronized) {
                        console.log('The order id is:' + orderID);
                        this.$store.state.editedOrder.id = orderID;
                        this.$store.state.editedOrder.destiny = 1;
                        this.$store.state.order.edt = true;
                    }
                } else {
                    console.log('The order id is:' + orderID);
                    this.$store.state.editedOrder.id = orderID;
                    this.$store.state.editedOrder.destiny = 1;
                    this.$store.state.order.edt = true;
                }
            } else if (origin == 'line-up') {
                console.log('The order id is:' + orderID);
                this.$store.state.editedOrder.id = orderID;
                this.$store.state.editedOrder.destiny = 1;
                this.$store.state.order.edt = true;
            }
        },
        checkSize() {
            if (this.$store.state.mini == true) {
                this.width = '7';
            } else {
                this.width = '6';
            }
        },
        getDriverByTerminaBadge: function () {
            axios
                .get('driver-badge/by/terminal')
                .then(response => {
                    this.driversBadge = response.data;
                })
                .catch(function (error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
            console.log(this.split_types);
        },
        loadSplitTypes: function () {
            axios
                .get('split-type')
                .then(response => {
                    this.split_types = response.data;
                })
                .catch(function (error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
            console.log(this.split_types);
        },
        loadShiftHeaders: function () {
            this.$store.state.isLoading = true;
            axios
                .get('shift-header/dates/15')
                .then(response => {
                    this.shift_headers = response.data.data;
                    console.log(this.shift_headers);
                    // this.chargeShift();
                    this.loadCurrentShift(this.shift_headers);
                })
                .catch(function (error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadOrderLineUp: function () {
            var str = this.$store;
            this.$store.state.isLoading = true;
            this.dataLoading = true;
            var query_string = '';
            this.retain.length = 0;
            this.Interplant.length = 0;
            this.private.length = 0;
            this.orders.length = 0;
            if (this.filteredYards.length == 0) {
                query_string = 'order/active';
            } else {
                console.log(this.filteredYards);
                query_string = 'order/active/regions';
                var parms = {
                    regions: this.filteredYards
                };
            }
            axios
                .post(query_string, parms)
                .then(async response => {
                    this.orders = response.data;
                    this.orders.forEach(order =>{
                        order.Drives = JSON.parse(order.Drives);
                    });
                    console.log(this.orders)
                    // let maxRTHrs = await this.getMaxRTHrs();
                    // console.log(maxRTHrs);

                    // for (let ord of this.orders) {
                    //     let ordRT = maxRTHrs.filter(rt => rt.OrderID == ord.OrderID);
                    //     if (ordRT.length != 0) {
                    //         ord.RTHrs = ordRT[0].MaxRTHrs;
                    //     }
                    // }

                    this.retain = this.orders.filter(x => {
                        return x.StationType == 1;
                    });
                    this.Interplant = this.orders.filter(x => {
                        return x.StationType == 3;
                    });
                    this.private = this.orders.filter(x => {
                        return x.StationType == 2;
                    });

                    console.log(this.retain);

                    this.dataLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadCurrentShift: function (shiftHeaders) {
            console.log('----- Cargar shift actual', shiftHeaders);
            const today = new Date();
            const year = today.getFullYear();
            const month = (today.getMonth() + 1).toString().padStart(2, '0');
            const day = today
                .getDate()
                .toString()
                .padStart(2, '0');
            let formattedDate;

            if (today.getHours() > 11) {
                formattedDate = `${year}-${month}-${day} PM`;
            } else {
                formattedDate = `${year}-${month}-${day} AM`;
            }

            console.log(formattedDate);

            for (let sh of shiftHeaders) {
                if (sh.ShiftDate == formattedDate) {
                    this.header = sh;
                    break;
                }
            }

            this.loadShifts(true);
        },
        async fnShiftConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to unfinalize this Shift',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.FinalizeShift(itm);
            }
        },
        getSpecificShift: async function (shiftDetail, index) {
            this.$store.state.isLoading = true;
            console.log(index);
            var str = this.$store;
            let shiftData;
            await axios
                .get('shift-detail/specific/' + shiftDetail)
                .then(response => {
                    shiftData = response.data;
                    this.shifts[index].ShiftInterface = [shiftData];
                    console.log(shiftData);
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
            return shiftData;
        },
        showPaperwork: async function (order) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            console.log(order);
            let paperworkDataOrder = [];
            await axios
                .get('order/show-paperwork/' + order.OrderID)
                .then(response => {
                    console.log(response.data);
                    paperworkDataOrder = response.data;

                    if (paperworkDataOrder.length == 0) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'This order has no paperwork scanned by the driver yet.'
                        });
                    } else {
                        this.paperworkData = paperworkDataOrder;
                        this.showPaperworkByOrder = true;
                    }
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        showOrderDetails: async function (orderID) {
            console.log(orderID);
            this.orderDetArr = [];
            let products = await this.retrieveProductsByOrder(orderID);
            console.log(products);
            this.orderDetArr = products;
        },
        showBOLQuantities: async function (order) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            console.log(order);
            let bolDataOrder = [];
            await axios
                .get('order/show-bol-quantities/' + order.OrderID)
                .then(response => {
                    console.log(response.data);
                    bolDataOrder = response.data;

                    if (bolDataOrder.length == 0) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'This order has no quantities registered by the driver yet.'
                        });
                    } else {
                        this.bolData = bolDataOrder;
                        this.showBOLDataByOrder = true;
                    }
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        retrieveProductsByOrder: async function (orderID) {
            var str = this.$store;
            let products = [];
            await axios
                .get('order-detail/order/' + orderID)
                .then(response => {
                    //console.log(response.data.data);
                    products = response.data.data;
                    //str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                    //str.state.isLoading = false;
                });

            return products;
        },
        retrieveReadingsBySite: async function (stationNum) {
            var str = this.$store;
            let readings = [];
            await axios
                .get('ftp-readings/reads/station/' + stationNum)
                .then(response => {
                    //console.log(response.data);
                    readings = response.data;
                    //str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                    //str.state.isLoading = false;
                });

            return readings;
        },
        checkCurrentCompartments: function (order) {
            let { Comp1, Comp2, Comp3, Comp4, Comp5, Comp6 } = order;
            let compartments = { Comp1, Comp2, Comp3, Comp4, Comp5, Comp6 };
            let realCompartments = {};
            for (let c in compartments) {
                if (compartments[c] != null && compartments[c] != 0) {
                    realCompartments[c] = compartments[c];
                }
            }
            return realCompartments;
        },
        fillsProductDistributionCapacity: function (realCompartments) {
            for (let comp in realCompartments) {
                for (let dist of this.productDistribution) {
                    if (dist.Comp == comp) {
                        dist.Capacity = realCompartments[comp];
                        dist.VirtualCapacity = realCompartments[comp];
                        dist.Available = true;
                        break;
                    }
                }
            }

            this.productDistribution = this.sortItemsByFactor(
                this.productDistribution,
                'Capacity',
                'desc'
            );

            let sumCapacity = 0;
            let diff;
            for (let dist of this.productDistribution) {
                sumCapacity += dist.Capacity;
            }

            if (sumCapacity > 58000) {
                diff = sumCapacity - 58000;
            } else if (sumCapacity > 54000) {
                diff = sumCapacity - 54000;
            }

            this.productDistribution[0].VirtualCapacity -= diff;

            // Sum capacities
            let totalCompCap = 0;
            let totalVirtualCap = 0;
            for (let dist of this.productDistribution) {
                totalCompCap += dist.Capacity;
                totalVirtualCap += dist.VirtualCapacity;
            }

            this.totalsPrdDist.TotalCompCapacity = totalCompCap;
            this.totalsPrdDist.TotalVirtualCapacity = totalVirtualCap;
            this.productDistribution = this.sortItemsByFactor(
                this.productDistribution,
                'Comp',
                'desc'
            );
        },
        groupingProducts: function (products) {
            let groupedProducts = {};
            for (let p of products) {
                let { ProductID, ...rest } = p;
                if (!groupedProducts[ProductID]) {
                    groupedProducts[ProductID] = { ProductID, ...rest };
                } else {
                    groupedProducts[ProductID].Quantity += p.Quantity;
                    groupedProducts[ProductID].DispatchedQuantity +=
                        p.DispatchedQuantity;
                }
            }
            let grpProds = Object.values(groupedProducts);
            console.log(grpProds);
            return grpProds;
        },
        groupingUllage: function (readings) {
            let tanksByProduct = {};
            let totalUllageByProduct = {};
            for (let r of readings) {
                let { ProductId, Ullage, ...rest } = r;

                if (!totalUllageByProduct[ProductId]) {
                    totalUllageByProduct[ProductId] = {
                        ProductId,
                        Ullage,
                        ...rest
                    };
                    tanksByProduct[ProductId] = 1;
                } else {
                    totalUllageByProduct[ProductId].Ullage += Ullage;
                    tanksByProduct[ProductId] = tanksByProduct[ProductId]++;
                }
            }
            let totalUllg = Object.values(totalUllageByProduct);
            console.log(totalUllg);
            return totalUllg;
        },
        adjustDispatchQuantity: async function (grpProds, totalUllg) {
            var str = this.$store;
            for (let p of grpProds) {
                for (let u of totalUllg) {
                    if (p.ProductID == u.ProductId) {
                        if (p.DispatchedQuantity <= u.Ullage) {
                            console.log(
                                'All good, there is enough space to dispatch that quantity'
                            );
                        } else {
                            // DispatchedQuantity is greater than current ullage
                            // the DispatchedQuantity should be adjusted.
                            let newDispatchedQuantity =
                                Math.floor(Number(u.Ullage) / 5) * 5;

                            // Updates DispatchedQuantity for that product locally
                            p.DispatchedQuantity = newDispatchedQuantity;

                            // Update OrderDetails
                            let params = {
                                ProductQuantity: newDispatchedQuantity,
                                DispatchedQuantity: newDispatchedQuantity
                            };
                            //str.state.isLoading = true;
                            await axios
                                .put('order-detail/' + p.id, params, {
                                    headers: {
                                        Authorization:
                                            'Bearer ' + this.$store.state.token
                                    }
                                })
                                // eslint-disable-next-line no-unused-vars
                                .then(response => {
                                    console.log(response.data);
                                    str.dispatch('setSnackbar', {
                                        color: 'success',
                                        text:
                                            'The DispatchedQuantity was adjusted for the product ' +
                                            p.Product
                                    });
                                    //str.state.isLoading = false;
                                })
                                .catch(function (error) {
                                    console.log(error);
                                    str.dispatch('setSnackbar', {
                                        color: 'error',
                                        text:
                                            'Something is wrong. Please contact the administrator.'
                                    });
                                    //str.state.isLoading = false;
                                });
                        }

                        break;
                    }
                }
            }

            return grpProds;
        },
        buildTankRelationByProduct: function (readings) {
            let tankRelation = {};
            for (let tk of readings) {
                let { ProductId, TankNum } = tk;

                if (!tankRelation[ProductId]) {
                    tankRelation[ProductId] = [];
                    tankRelation[ProductId].push({ TankNum, Available: true });
                } else {
                    tankRelation[ProductId].push({ TankNum, Available: true });
                }
            }
            console.log(tankRelation);
            return tankRelation;
        },
        updateTankRelation: function (tankRelation, currentProduct) {
            for (let rel of tankRelation[currentProduct]) {
                if (rel.Available) {
                    // The currently working tank is disabled now
                    rel.Available = false;
                    break;
                } else {
                    // This tank is already disabled, go to the next
                    console.log(
                        'This tank is already disabled, go to the next'
                    );
                }
            }
            return tankRelation;
        },
        checkTankAvailability: function (tankRelation, currentProduct) {
            let tanksAvailable = tankRelation[currentProduct].filter(
                tk => tk.Available == true
            );
            let tanksForCurrPrd = tanksAvailable.length;
            return tanksForCurrPrd;
        },
        defineProductDistributionByCompartment: function (
            readings,
            tankRelation,
            products
        ) {
            console.log(
                'Readings: ',
                readings,
                'Tank Relation: ',
                tankRelation,
                'Products: ',
                products
            );

            //let compsAv = this.productDistribution.filter(comp => comp.Available != null);
            //let numOfComps = compsAv.length;
            let thereIsReg = false;
            for (let tk of readings) {
                let searchREG = tk.Product.search('REG');
                console.log(searchREG);
                if (searchREG != -1) {
                    thereIsReg = true;
                    continue;
                }

                let currentProduct = tk.ProductId;
                let product = products.filter(
                    prd => prd.ProductID == currentProduct
                );
                let quantity = product[0].DispatchedQuantity;
                let tanksForCurrPrd = this.checkTankAvailability(
                    tankRelation,
                    currentProduct
                );
                tankRelation = this.updateTankRelation(
                    tankRelation,
                    currentProduct
                );

                // Calculates the product distribution
                for (let comp of this.productDistribution) {
                    if (!comp.Available && comp.Available != null) {
                        continue;
                    }

                    let diff = quantity - comp.VirtualCapacity;
                    let minimumRequired = comp.VirtualCapacity * 0.8;

                    tanksForCurrPrd = this.checkTankAvailability(
                        tankRelation,
                        currentProduct
                    );
                    if (diff < 0 && quantity >= minimumRequired) {
                        if (tanksForCurrPrd >= 1) {
                            comp.Product = product[0].Product;
                            comp.ProductID = product[0].ProductID;
                            comp.Quantity = comp.VirtualCapacity;
                            comp.Available = false;

                            // Update the DispatchedQuantity locally
                            let diffQty = comp.VirtualCapacity - quantity;
                            for (let prd of products) {
                                if (prd.ProductID == currentProduct) {
                                    prd.DispatchedQuantity -= diffQty;
                                    break;
                                }
                            }
                        } else {
                            comp.Product = product[0].Product;
                            comp.ProductID = product[0].ProductID;
                            comp.Quantity = quantity;
                            comp.Available = false;
                        }
                        break;
                    } else if (diff >= 0) {
                        comp.Product = product[0].Product;
                        comp.ProductID = product[0].ProductID;
                        comp.Quantity = comp.VirtualCapacity;
                        comp.Available = false;

                        // Update the DispatchedQuantity locally
                        for (let prd of products) {
                            if (prd.ProductID == currentProduct) {
                                prd.DispatchedQuantity -= comp.VirtualCapacity;
                                break;
                            }
                        }
                    } else {
                        console.log(
                            'The quantity does not reach the minimum required.'
                        );
                    }
                }
            }

            if (thereIsReg) {
                for (let tk of readings) {
                    let searchREG = tk.Product.search('REG');
                    console.log(searchREG);
                    if (searchREG != -1) {
                        let currentProduct = tk.ProductId;
                        let product = products.filter(
                            prd => prd.ProductID == currentProduct
                        );
                        let quantity = product[0].DispatchedQuantity;
                        let tanksForCurrPrd = this.checkTankAvailability(
                            tankRelation,
                            currentProduct
                        );
                        tankRelation = this.updateTankRelation(
                            tankRelation,
                            currentProduct
                        );

                        // Calculates the product distribution
                        for (let comp of this.productDistribution) {
                            if (!comp.Available && comp.Available != null) {
                                continue;
                            }

                            /*// Check for the last comp (6, 5, etc.) to get full load
                            let currentComp = comp.Comp;
                            let comp = currentComp.match(/\d+/);
                            let compNum = Number(comp[0]);
                            console.log(comp, compNum);

                            if (compNum == numOfComps) {
                                let maxLoad = this.totalsPrdDist.TotalVirtualCapacity;
                                let sumCompsCap = 0;
                                for (let comp of this.productDistribution) {
                                    sumCompsCap += comp.Quantity;
                                }
                                let diffCap = maxLoad - sumCompsCap;
                                comp.VirtualCapacity += diffCap;
                            }*/

                            let diff = quantity - comp.VirtualCapacity;
                            let minimumRequired = comp.VirtualCapacity * 0.8;

                            tanksForCurrPrd = this.checkTankAvailability(
                                tankRelation,
                                currentProduct
                            );
                            if (diff < 0 && quantity >= minimumRequired) {
                                if (tanksForCurrPrd >= 1) {
                                    comp.Product = product[0].Product;
                                    comp.ProductID = product[0].ProductID;
                                    comp.Quantity = comp.VirtualCapacity;
                                    comp.Available = false;

                                    // Update the DispatchedQuantity locally
                                    let diffQty =
                                        comp.VirtualCapacity - quantity;
                                    for (let prd of products) {
                                        if (prd.ProductID == currentProduct) {
                                            prd.DispatchedQuantity -= diffQty;
                                            break;
                                        }
                                    }
                                } else {
                                    comp.Product = product[0].Product;
                                    comp.ProductID = product[0].ProductID;
                                    comp.Quantity = quantity;
                                    comp.Available = false;
                                }
                                break;
                            } else if (diff >= 0) {
                                comp.Product = product[0].Product;
                                comp.ProductID = product[0].ProductID;
                                comp.Quantity = comp.VirtualCapacity;
                                comp.Available = false;

                                // Update the DispatchedQuantity locally
                                for (let prd of products) {
                                    if (prd.ProductID == currentProduct) {
                                        prd.DispatchedQuantity -=
                                            comp.VirtualCapacity;
                                        break;
                                    }
                                }
                            } else {
                                console.log(
                                    'The quantity does not reach the minimum required.'
                                );
                            }
                        }
                    }
                }
            }
        },
        showProductCompartments: async function (order) {
            console.log(order);
            var str = this.$store;
            this.$store.state.isLoading = true;

            // 1. Check the trailer compartments.
            let realCompartments = this.checkCurrentCompartments(order);
            console.log(realCompartments);
            // 1.1 Ensures that the compartments have capacities
            if (Object.keys(realCompartments).length == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This trailer has its compartments at 0 or null.'
                });
                str.state.isLoading = false;
                return;
            }

            // 2. Fills productDistribution (Capacity and VirtualCapacity)
            this.fillsProductDistributionCapacity(realCompartments);
            console.log(this.productDistribution);

            // 3. Retrieve the products and quantities on that order.
            let products = await this.retrieveProductsByOrder(order.OrderID);
            console.log(products);

            // 4. Retrieve readings from that site.
            let readings = await this.retrieveReadingsBySite(order.StationNum);
            let newReadings = [];
            // 4.1 Ensure only the necessary readings to check
            for (let prd of products) {
                for (let rd of readings) {
                    if (rd.ProductId == prd.ProductID) {
                        newReadings.push(rd);
                    }
                }
            }
            newReadings = this.sortItemsByFactor(newReadings, 'TankNum', 'asc');
            console.log(newReadings);
            this.currentReadings = newReadings;

            // 5. Builds the relation of the site tanks by product.
            let tankRelation = this.buildTankRelationByProduct(newReadings);

            // 6. Defines the distribution of products in compartments.
            this.defineProductDistributionByCompartment(
                newReadings,
                tankRelation,
                products
            );

            products = await this.retrieveProductsByOrder(order.OrderID);
            console.log(products);

            for (let prd of products) {
                prd.QtyAfterComps = 0;
                for (let dist of this.productDistribution) {
                    if (prd.ProductID == dist.ProductID) {
                        prd.QtyAfterComps += dist.Quantity;
                    }
                }
            }

            let sumPrdQtys = 0;
            for (let prd of products) {
                sumPrdQtys += prd.QtyAfterComps;
            }
            this.productDistribution = this.sortItemsByFactor(
                this.productDistribution,
                'Comp',
                'asc'
            );
            this.totalsPrdDist.TotalPrdQty = sumPrdQtys;
            this.groupProducts = products;
            this.$store.state.isLoading = false;
            this.$store.state.dispatch.productCompartments = true;
        },
        loadShifts: function (filter) {
            this.$store.state.isLoading = true;
            this.shiftLoading = true;
            this.shiftOrders = [];
            this.shiftDetails = [];
            this.driverBadges = [];
            this.shifts = [];
            var query_string = '';

            console.log(this.header);
            if (filter) {
                this.filteredYards = [];
            }
            if (this.filteredYards.length == 0) {
                query_string = 'shift-detail/shift/' + this.header.ShiftId;
            } else {
                query_string =
                    'shift-detail/shift/regions/' +
                    this.header.ShiftId +
                    '/' +
                    this.filteredYards;
            }
            axios
                .get(query_string)
                .then(async response => {
                    this.shifts = response.data;
                    console.log(this.shifts);
                    for (const shift in this.shifts) {
                        this.shifts[shift].LastContained = JSON.parse(this.shifts[shift].LastContained);
                        this.shifts[shift].View = true;

                        if (this.shifts[shift].SpecificProductOnly > 0) {
                            this.shifts[shift].colorDistpatch = '#00838F';
                        } else {
                            this.shifts[shift].colorDistpatch = 'primary';
                        }

                        this.shiftOrders.push([shift]);
                        this.shiftOrders[shift].splice(0);
                        this.driverBadges.push([shift]);
                        this.driverBadges[shift].splice(0);
                        this.shiftDetails.push(this.shifts[shift].ShiftDetail);
                        this.shifts[shift].ColorSTDBtn =
                            this.shifts[shift].PendingRevises == 1
                                ? '#ceb500'
                                : '#4f83cc';

                        this.shifts[shift].ShiftInterface = [
                            this.shifts[shift]
                        ];

                        if (this.shifts[shift].DriverEleosApp == 1) {
                            await this.checkSyncPlatforms(
                                this.shifts[shift].ShiftDetail,
                                'not-apply',
                                'load-shifts'
                            );
                        }
                        await axios
                            .get(
                                'driver-badge/dispatch/' +
                                this.shifts[shift].ShiftDetail,
                                {
                                    headers: {
                                        Authorization:
                                            'Bearer ' + this.$store.state.token
                                    }
                                }
                            )
                            .then(response => {
                                console.log(response.data);
                                for (const badge in response.data) {
                                    this.driverBadges[shift].push(
                                        response.data[badge]
                                    );
                                }
                            })
                            .catch(function (error) {
                                this.$store.state.isLoading = false;
                                console.log(error);
                            });

                        await axios
                            .get(
                                'order/shift/' + this.shifts[shift].ShiftDetail,
                                {
                                    headers: {
                                        Authorization:
                                            'Bearer ' + this.$store.state.token
                                    }
                                }
                            )
                            .then(async response => {
                                for (const order in response.data) {
                                    this.shiftOrders[shift].push(
                                        response.data[order]
                                    );
                                }
                            })
                            .catch(function (error) {
                                this.$store.state.isLoading = false;
                                console.log(error);
                            });

                        console.log(this.shifts[shift]);
                    }

                    console.log(this.shifts);
                    console.log('shiftDetail', this.shiftDetails);
                    console.log('badges', this.driverBadges);
                    console.log('shiftOrders', this.shiftOrders);
                    this.filterOrd();

                    this.getYards();
                })
                .catch(function (error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });

            axios
                .get('shift-header/' + this.header.ShiftId)
                .then(async response => {
                    this.headerComment = response.data.ShiftComments;
                })
                .catch(function (error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        filterOrdRemove(sttID) {
            var cont = 0;
            const index = this.arrStations.findIndex(elm => {
                return elm == sttID;
            });
            this.arrStations.forEach(element => {
                if (element == sttID) {
                    cont++;
                }
            });
            console.log('Menos', this.arrStations);
            this.arrStations.splice(index, 1);
            if (cont == 2) {
                let duplicados = [];
                const tempStation = this.arrStations.sort();
                for (let i = 0; i < tempStation.length; i++) {
                    if (tempStation[i + 1] === tempStation[i]) {
                        duplicados.push(tempStation[i]);
                    }
                }

                for (let i = 0; i < this.shiftOrders.length; i++) {
                    if (this.shiftOrders[i].length > 0) {
                        this.shiftOrders[i].forEach(ord => {
                            if (ord.StationID == sttID) {
                                ord.dpColor = '#FFFFFF';
                            }
                        });
                    }
                }
            }
        },
        filterOrd: function () {
            var arrStation = [];
            for (let i = 0; i < this.shiftOrders.length; i++) {
                if (this.shiftOrders[i].length > 0) {
                    this.shiftOrders[i].forEach(element => {
                        arrStation.push(element.StationID);
                    });
                }
            }
            this.arrStations = arrStation;
            console.log(this.arrStations);
            let duplicados = [];
            const tempStation = arrStation.sort();
            for (let i = 0; i < tempStation.length; i++) {
                if (tempStation[i + 1] === tempStation[i]) {
                    duplicados.push(tempStation[i]);
                }
            }

            for (let i = 0; i < this.shiftOrders.length; i++) {
                if (this.shiftOrders[i].length > 0) {
                    this.shiftOrders[i].forEach(ord => {
                        duplicados.forEach(dp => {
                            if (ord.StationID == dp) {
                                ord.dpColor = 'blue';
                                //console.log('Add Blue', ord);
                            }
                        });
                    });
                }
            }
        },
        getYards: function () {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('shift-detail/regions/shift/' + this.header.ShiftId)
                .then(response => {
                    this.yards = response.data;
                    this.shiftLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
            str.state.isLoading = false;
        },
        startOrder: function (index) {
            this.editedIndex = index;
            this.tempSearch = this.search;
            this.search = '';
            console.log(this.editedIndex);
        },
        addLineUp: function () {
            this.toLine = 1;
        },
        recall: async function (reviseStatus) {
            console.log(this.toLine, this.toOrder);
            if (this.toLine == 0 && this.toOrder == 1) {
                console.log('From LineUp to Shift');
                let idx = this.idxAdd;

                await this.loadOrderShift(
                    this.shifts[this.idxAdd].ShiftDetail,
                    this.idxAdd
                );

                console.log(this.shifts[idx], reviseStatus);
                let eleosCurrent = await this.checkForEleosCurrent(
                    this.shifts[idx].ShiftDetail
                );
                if (
                    this.shifts[idx].SentMailCounter > 0 &&
                    this.shifts[idx].DriverEleosApp == 1 &&
                    reviseStatus &&
                    eleosCurrent == 1
                ) {
                    console.log('Dentro del if');
                    let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                        this.shifts[idx].ShiftDetail,
                        idx
                    );
                    await this.getCurrentShiftInfo(
                        this.shifts[idx].ShiftDetail,
                        idx,
                        newShiftInfoDispatch
                    );
                }
            } else if (this.toLine == 1 && this.toOrder == 0) {
                console.log('From Shift to LineUp');
                console.log(this.orders);
                await this.loadOrderShift(
                    this.shifts[this.idxChange].ShiftDetail,
                    this.idxChange
                );

                let eleosCurrent = await this.checkForEleosCurrent(
                    this.shifts[this.idxChange].ShiftDetail
                );
                if (
                    this.shifts[this.idxChange].SentMailCounter > 0 &&
                    this.shifts[this.idxChange].DriverEleosApp == 1 &&
                    reviseStatus &&
                    eleosCurrent == 1
                ) {
                    console.log('Dentro del if');
                    let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                        this.shifts[this.idxChange].ShiftDetail,
                        this.idxChange
                    );
                    await this.getCurrentShiftInfo(
                        this.shifts[this.idxChange].ShiftDetail,
                        this.idxChange,
                        newShiftInfoDispatch
                    );
                }
            } else if (this.toLine == 0 && this.toOrder == 0) {
                console.log('From Shift to Shift');
                console.log(this.idxAddCopy, this.idxRemvCopy);

                let addCopy = this.idxAddCopy;
                let rmvCopy = this.idxRemvCopy;

                await this.loadOrderShift(
                    this.shifts[addCopy].ShiftDetail,
                    addCopy
                );

                await this.loadOrderShift(
                    this.shifts[rmvCopy].ShiftDetail,
                    rmvCopy
                );
                console.log('Here loading');
                console.log(this.shifts[addCopy], this.shifts[rmvCopy]);
                console.log(reviseStatus);

                let eleosCurrentAdd = await this.checkForEleosCurrent(
                    this.shifts[addCopy].ShiftDetail
                );
                if (
                    this.shifts[addCopy].SentMailCounter > 0 &&
                    this.shifts[addCopy].DriverEleosApp == 1 &&
                    reviseStatus &&
                    eleosCurrentAdd == 1
                ) {
                    console.log('Dentro del if');
                    let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                        this.shifts[addCopy].ShiftDetail,
                        addCopy
                    );
                    await this.getCurrentShiftInfo(
                        this.shifts[addCopy].ShiftDetail,
                        addCopy,
                        newShiftInfoDispatch
                    );
                }

                let eleosCurrentRmv = await this.checkForEleosCurrent(
                    this.shifts[rmvCopy].ShiftDetail
                );
                if (
                    this.shifts[rmvCopy].SentMailCounter > 0 &&
                    this.shifts[rmvCopy].DriverEleosApp == 1 &&
                    reviseStatus &&
                    eleosCurrentRmv == 1
                ) {
                    console.log('Dentro del if');
                    let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                        this.shifts[rmvCopy].ShiftDetail,
                        rmvCopy
                    );
                    await this.getCurrentShiftInfo(
                        this.shifts[rmvCopy].ShiftDetail,
                        rmvCopy,
                        newShiftInfoDispatch
                    );
                }

                this.idxRemvCopy = null;
                this.idxAddCopy = null;
            }
            this.changeOrd = 0;
            this.toLine = 0;
            this.toOrder = 0;
        },
        checkSyncPlatforms: async function (fromId, toId, evt) {
            var str = this.$store;

            if (evt !== 'load-shifts') {
                this.$store.state.isLoading = true;
            }

            let params = {
                FromId: fromId,
                ToId: toId
            };

            let syncPlatformsData;
            await axios
                .post('shift-detail/sync-platforms', params)
                .then(response => {
                    console.log(response.data);
                    syncPlatformsData = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
            console.log(syncPlatformsData);

            // Only synchronization is needed, the orders will be loaded later in the loadShifts function itself.
            if (evt == 'load-shifts') {
                console.log(
                    'Only synchronization is needed, the orders will be loaded later in the loadShifts function itself.'
                );
                return;
            }

            if (syncPlatformsData == 'Synchronized') {
                // Things to do depending on the origin of the event
                if (
                    evt == 'view-order' ||
                    evt == 'preload' ||
                    evt == 'un-preload' ||
                    evt == 'split' ||
                    evt == 'un-split' ||
                    evt == 'tools' ||
                    evt == 'itself'
                ) {
                    return true;
                } else if (evt == 'refresh-orders') {
                    let index = this.shiftDetails.indexOf(fromId);
                    console.log('test');
                    await this.getOrdersByShiftDetail(
                        fromId,
                        index,
                        '',
                        'just-refresh'
                    );
                } else {
                    this.executeEventsBetweenShifts(evt);
                }
            } else {
                // Activates the spinner to prevent the dispatcher from making changes
                for (let sh of syncPlatformsData) {
                    let index = this.shiftDetails.indexOf(sh.ShiftDetail);
                    this.shifts[index].View = false;
                }

                for (let sh of syncPlatformsData) {
                    let index = this.shiftDetails.indexOf(sh.ShiftDetail);
                    console.log('test');
                    await this.getOrdersByShiftDetail(
                        sh.ShiftDetail,
                        index,
                        sh.DriverName,
                        'synchronization'
                    );
                }

                if (evt == 'itself') {
                    return false;
                }
            }
        },
        executeEventsBetweenShifts: async function (evt) {
            if (evt.from != evt.to) {
                console.log('From different draggables', evt);
                if (this.editedIndex != null) {
                    console.log('Here', this.editedIndex, this.addedOrder);
                    if (this.addedOrder) {
                        console.log(this.shiftOrders);
                        if (
                            this.shiftOrders[this.editedIndex][evt.newIndex]
                                .isSpecific > 0 ||
                            this.shifts[this.editedIndex].SpecificProductOnly >
                            0
                        ) {
                            if (
                                this.shifts[this.editedIndex]
                                    .SpecificProductOnly ==
                                this.shiftOrders[this.editedIndex][evt.newIndex]
                                    .isSpecific
                            ) {
                                console.log(
                                    'Added to a driver assign shift detail'
                                );
                                console.log(
                                    this.shiftOrders[this.editedIndex][
                                        evt.newIndex
                                    ].OrderID
                                );
                                console.log(evt.newIndex + 1);
                                console.log(
                                    this.shiftDetails[this.editedIndex]
                                );
                                await this.assignLoad(
                                    this.shiftOrders[this.editedIndex][
                                        evt.newIndex
                                    ].OrderID,
                                    this.shiftOrders[this.editedIndex][
                                        evt.newIndex
                                    ].OrderStatus,
                                    this.shifts[this.editedIndex],
                                    this.editedIndex,
                                    evt.newIndex,
                                    this.shiftOrders[this.editedIndex][
                                        evt.newIndex
                                    ].ROHrs
                                );

                                if (
                                    evt.from.id != 'line-up' &&
                                    evt.to.id != 'line-up'
                                ) {
                                    console.log(
                                        'From executeEventsBetweenShifts'
                                    );
                                    let shDet = Number(evt.from.id);
                                    let index = this.shiftDetails.indexOf(
                                        shDet
                                    );
                                    await this.updateForOnlyChange(index);
                                }
                            } else {
                                this.$store.dispatch('setSnackbar', {
                                    color: 'error',
                                    text: 'Product does not match the trailer'
                                });
                                this.recall(false);
                            }
                        } else {
                            console.log(
                                'Added to a driver assign shift detail'
                            );
                            console.log(
                                this.shiftOrders[this.editedIndex][evt.newIndex]
                                    .OrderID
                            );
                            console.log(evt.newIndex + 1);
                            console.log(this.shiftDetails[this.editedIndex]);
                            await this.assignLoad(
                                this.shiftOrders[this.editedIndex][evt.newIndex]
                                    .OrderID,
                                this.shiftOrders[this.editedIndex][evt.newIndex]
                                    .OrderStatus,
                                this.shifts[this.editedIndex],
                                this.editedIndex,
                                evt.newIndex,
                                this.shiftOrders[this.editedIndex][evt.newIndex]
                                    .ROHrs
                            );

                            if (
                                evt.from.id != 'line-up' &&
                                evt.to.id != 'line-up'
                            ) {
                                console.log('From executeEventsBetweenShifts');
                                let shDet = Number(evt.from.id);
                                let index = this.shiftDetails.indexOf(shDet);
                                await this.updateForOnlyChange(index);
                            }
                        }
                        this.addedOrder = false;
                    } else if (this.changedOrder) {
                        console.log(
                            'Changed order positions, renumber load ord num'
                        );
                    } else {
                        console.log('Moved back to lineup reset shift detail');
                        console.log(this.orders[evt.newIndex].OrderStatus);
                        this.filterOrdRemove(
                            this.orders[evt.newIndex].StationID
                        );
                        this.de_assignLoad(
                            this.orders[evt.newIndex].OrderID,
                            this.orders[evt.newIndex].OrderStatus
                        );
                        this.orders[evt.newIndex].ShiftDetail = 0;
                        this.orders[evt.newIndex].LoadNum = null;
                        this.orders[evt.newIndex].LoadNumOrd = null;
                        /*if(this.orders[evt.newIndex].OrderStatus == "PRELOAD" || this.orders[evt.newIndex].OrderStatus == "PRLDISPAT"){
                            console.log("test");
                            await this.getOrdersByShiftDetail(this.shifts[this.editedIndex].ShiftDetail, this.editedIndex, '', 'just-refresh');
                        }else{
                            console.log('Moved back to lineup reset shift detail');
                            console.log(this.orders[evt.newIndex].OrderStatus);
                            this.filterOrdRemove(
                                this.orders[evt.newIndex].StationID
                            );
                            this.de_assignLoad(
                                this.orders[evt.newIndex].OrderID,
                                this.orders[evt.newIndex].OrderStatus
                            );
                            this.orders[evt.newIndex].ShiftDetail = 0;
                            this.orders[evt.newIndex].LoadNum = null;
                            this.orders[evt.newIndex].LoadNumOrd = null;
                        }*/
                    }
                    this.editedIndex = null;
                }
            }
        },
        endOrder: async function (evt) {
            //var str = this.$store;

            let draggableFromId = evt.from.id;
            let draggableToId = evt.to.id;

            let fromId;
            let toId;

            if (draggableFromId == 'line-up' && draggableToId != 'line-up') {
                fromId = draggableFromId;
                toId = Number(draggableToId);
                let index = this.shiftDetails.indexOf(toId);
                let shift = this.shifts[index];

                if (shift.DriverEleosApp == 1) {
                    await this.checkSyncPlatforms(fromId, toId, evt);
                } else {
                    this.executeEventsBetweenShifts(evt);
                }
            } else if (
                draggableToId == 'line-up' &&
                draggableFromId != 'line-up'
            ) {
                fromId = Number(draggableFromId);
                toId = draggableToId;
                let index = this.shiftDetails.indexOf(fromId);
                let shift = this.shifts[index];

                if (shift.DriverEleosApp == 1) {
                    await this.checkSyncPlatforms(fromId, toId, evt);
                } else {
                    this.executeEventsBetweenShifts(evt);
                }
            } else if (
                draggableFromId == 'line-up' &&
                draggableToId == 'line-up'
            ) {
                console.log('Nothing happens; from and to are line-up.');
                return;
            } else {
                // Here, both from and to are different ShiftDetail
                fromId = Number(draggableFromId);
                toId = Number(draggableToId);

                let indexFrom = this.shiftDetails.indexOf(fromId);
                let shiftFrom = this.shifts[indexFrom];

                let indexTo = this.shiftDetails.indexOf(toId);
                let shiftTo = this.shifts[indexTo];

                if (
                    shiftFrom.DriverEleosApp == 1 &&
                    shiftTo.DriverEleosApp == 1
                ) {
                    console.log(
                        'Both Shifts have the same Eleos Status: enabled.'
                    );
                    await this.checkSyncPlatforms(fromId, toId, evt);
                } else if (
                    shiftFrom.DriverEleosApp == 1 &&
                    shiftTo.DriverEleosApp != 1
                ) {
                    let fromIsSynchronized = await this.checkSyncPlatforms(
                        fromId,
                        'not-apply',
                        'itself'
                    );

                    if (fromIsSynchronized) {
                        this.executeEventsBetweenShifts(evt);
                        return;
                    }

                    this.loadOrderShift(
                        shiftFrom.ShiftDetail,
                        indexFrom,
                        'endOrder'
                    );
                    this.loadOrderShift(
                        shiftTo.ShiftDetail,
                        indexTo,
                        'endOrder'
                    );
                } else if (
                    shiftFrom.DriverEleosApp != 1 &&
                    shiftTo.DriverEleosApp == 1
                ) {
                    let toIsSynchronized = await this.checkSyncPlatforms(
                        toId,
                        'not-apply',
                        'itself'
                    );

                    if (toIsSynchronized) {
                        this.executeEventsBetweenShifts(evt);
                        return;
                    }

                    this.loadOrderShift(
                        shiftFrom.ShiftDetail,
                        indexFrom,
                        'endOrder'
                    );
                    this.loadOrderShift(
                        shiftTo.ShiftDetail,
                        indexTo,
                        'endOrder'
                    );
                } else if (
                    shiftFrom.DriverEleosApp != 1 &&
                    shiftTo.DriverEleosApp != 1
                ) {
                    console.log(
                        'Both Shifts have the same Eleos Status: disabled.'
                    );
                    this.executeEventsBetweenShifts(evt);
                }
            }
        },
        chargeModalTrailer(x, y) {
            console.log(this.shifts[x].ShiftDetail, y.ShiftDetail);
            this.$store.state.dispatch.shift = this.shifts[x].ShiftDetail;
            this.$store.state.dispatch.trailerID = this.shifts[x].TrailerID;
            this.$store.state.dispatch.canvas = true;
        },
        addOrder: function (index) {
            console.log(this.shiftOrders[index]);

            this.idxAdd = index;
            this.idxAddCopy = index;
            console.log('Add order list');
            console.log('add');
            this.addedOrder = true;
            this.editedIndex = index;
            this.changedOrder = false;
            this.AlterOrders = true;
        },
        removeOrder: async function (index) {
            this.idxRemv = index;
            this.idxRemvCopy = index;
            console.log('remove order list');
            this.changedOrder = false;
            this.AlterOrders = true;
            console.log('remove');
            console.log(index);
            this.idxChange = index;
            //this.updateLoadOrder(index);
        },
        changeOrder: function () {
            this.AlterOrders = true;
            this.changeOrd = 1;
            console.log('change');
            this.changedOrder = true;
            this.updateForOnlyChange(this.editedIndex);
        },
        updateLoadOrder: async function (driverIndex) {
            await this.updateFor(driverIndex);
            console.log(this.idxAdd, this.idxRemv);
            this.recall(true);
            console.log(this.shiftOrders[driverIndex]);
            // if (!this.changedOrder) {
            // }
        },
        updateActiveOrder: async function (
            shiftDetail,
            index,
            invocationOrigin = ''
        ) {
            console.log(shiftDetail, this.shiftOrders[index]);
            var str = this.$store;
            if (this.shiftOrders[index].length != 0) {
                console.log('Sí tiene loads.');

                // Identifies the last completed order to make decisions
                let lastOrderCompleted;
                for (let ord = 0; ord < this.shiftOrders[index].length; ord++) {
                    if (this.shiftOrders[index][ord].FinalizeOrder == 1) {
                        lastOrderCompleted = this.shiftOrders[index][ord];
                    } else if (ord == 0) {
                        lastOrderCompleted = null;
                        break;
                    } else {
                        break;
                    }
                }
                console.log(lastOrderCompleted);

                let orderParams = [];

                if (lastOrderCompleted == null) {
                    // Whether split or not, LoadNum 1 will always be for active orders when there is no completed order.
                    for (let ord of this.shiftOrders[index]) {
                        if (ord.LoadNum == 1) {
                            orderParams.push({
                                OrderID: ord.OrderID,
                                OrdActiveOrder: 1,
                                OrdLoadStatus: ord.OrdLoadStatus,
                                TempLoadStatus: ord.TempLoadStatus,
                                LoadNum: ord.LoadNum,
                                LoadNumOrd: ord.LoadNumOrd
                            });
                        } else {
                            orderParams.push({
                                OrderID: ord.OrderID,
                                OrdActiveOrder: 0,
                                OrdLoadStatus: ord.OrdLoadStatus,
                                TempLoadStatus: ord.TempLoadStatus,
                                LoadNum: ord.LoadNum,
                                LoadNumOrd: ord.LoadNumOrd
                            });
                        }
                    }
                } else {
                    // Here is when there is at least one completed order
                    let splitControl = false;
                    for (let ord of this.shiftOrders[index]) {
                        // This will store any OrderID that is greater than +1 to the LoadNum
                        // of the last completed order and ignore the others.
                        if (
                            ord.LoadNum == lastOrderCompleted.LoadNum &&
                            ord.LoadNumOrd > lastOrderCompleted.LoadNumOrd
                        ) {
                            console.log('splitControl = true', ord.OrderID);
                            orderParams.push({
                                OrderID: ord.OrderID,
                                OrdActiveOrder: 1,
                                OrdLoadStatus: ord.OrdLoadStatus,
                                TempLoadStatus: ord.TempLoadStatus,
                                LoadNum: ord.LoadNum,
                                LoadNumOrd: ord.LoadNumOrd
                            });
                            splitControl = true;
                        } else if (
                            ord.LoadNum ==
                            lastOrderCompleted.LoadNum + 1
                        ) {
                            if (splitControl) {
                                console.log('if splitControl', ord.OrderID);
                                orderParams.push({
                                    OrderID: ord.OrderID,
                                    OrdActiveOrder: 0,
                                    OrdLoadStatus: ord.OrdLoadStatus,
                                    TempLoadStatus: ord.TempLoadStatus,
                                    LoadNum: ord.LoadNum,
                                    LoadNumOrd: ord.LoadNumOrd
                                });
                            } else {
                                console.log('else splitControl', ord.OrderID);
                                orderParams.push({
                                    OrderID: ord.OrderID,
                                    OrdActiveOrder: 1,
                                    OrdLoadStatus: ord.OrdLoadStatus,
                                    TempLoadStatus: ord.TempLoadStatus,
                                    LoadNum: ord.LoadNum,
                                    LoadNumOrd: ord.LoadNumOrd
                                });
                            }
                        } else if (
                            ord.LoadNum >
                            lastOrderCompleted.LoadNum + 1
                        ) {
                            console.log('last else if', ord.OrderID);
                            orderParams.push({
                                OrderID: ord.OrderID,
                                OrdActiveOrder: 0,
                                OrdLoadStatus: ord.OrdLoadStatus,
                                TempLoadStatus: ord.TempLoadStatus,
                                LoadNum: ord.LoadNum,
                                LoadNumOrd: ord.LoadNumOrd
                            });
                        }
                    }
                }

                console.log(orderParams);

                let params = {
                    OrderParams: orderParams,
                    ShiftDetail: shiftDetail
                };

                await axios
                    .put('order/active-order', params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                    })
                    .catch(error => {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });

                if (
                    invocationOrigin == 'updateForOnlyChange' ||
                    invocationOrigin == 'onPreloadOrderToShiftClose'
                ) {
                    await this.loadOrderShift(
                        shiftDetail,
                        index,
                        'updateActiveOrder'
                    );
                }
            } else {
                console.log('No tiene loads.');
            }
        },
        updateFor: async function (driverIndex) {
            //  this.$store.state.isLoading = true;

            this.shifts[driverIndex].View = false;
            console.log('uppdateLoadOrder', driverIndex);
            console.log(this.shifts);
            var startTime = moment(this.shifts[driverIndex].ShiftStartTime);
            var grpLoadNum = 1;
            var numOrd = 0;
            var loadNum = 0;
            var hrs = 0;
            var eta = null;
            var order_values = {};
            var gp = 0;
            var d1,
                d2,
                rt,
                ro = 0;
            console.log(this.shiftOrders[driverIndex]);
            for (const num in this.shiftOrders[driverIndex]) {
                if (this.shiftOrders[driverIndex][num].LoadNumOrd == null) {
                    hrs = 3;
                    //this.shiftOrders[driverIndex][num].StandardHours[0]
                    //    .stHrs * 2;
                    eta = startTime
                        .add(hrs, 'hours')
                        .format('YYYY-MM-DD HH:mm:ss');
                    if (this.shiftOrders[driverIndex][num].RTTime > eta) {
                        rt = moment(this.shiftOrders[driverIndex][num].RTTime);
                        d1 = moment.duration(rt.diff(eta));
                        gp = d1.asHours().toFixed(2) * 1;
                    } else if (
                        this.shiftOrders[driverIndex][num].ROTime < eta
                    ) {
                        ro = moment(this.shiftOrders[driverIndex][num].ROTime);
                        d2 = moment.duration(ro.diff(eta));
                        gp = d2.asHours().toFixed(2) * 1;
                    }
                    numOrd = 0;
                    loadNum = +loadNum + 1;
                    order_values = {
                        LoadNum: loadNum,
                        LoadNumOrd: null,
                        ETATime: eta,
                        GoalPost: gp
                    };
                    var str = this.$store;
                    await axios
                        .put(
                            'order/' +
                            this.shiftOrders[driverIndex][num].OrderID,
                            order_values,
                            {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            }
                        )
                        // eslint-disable-next-line no-unused-vars
                        .then(response => {
                            console.log('Success! uppdateLoadOrder');
                            console.log('await');
                        })
                        .catch(function (error) {
                            str.state.isLoading = false;
                            console.log(error);
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                    this.shiftOrders[driverIndex][num].LoadNum = loadNum;
                    this.shiftOrders[driverIndex][num].GoalPost = gp;
                } else {
                    grpLoadNum = this.shiftOrders[driverIndex][num].LoadNum;
                    var grpLoadNumOrd = this.shiftOrders[driverIndex][num]
                        .LoadNumOrd;
                    numOrd = +numOrd + 1;
                    // console.log('loadNum', loadNum);
                    // console.log('groupNum', grpLoadNum);
                    if (grpLoadNum != loadNum) {
                        loadNum = +loadNum + 1;
                        numOrd = 1;
                    } else if (grpLoadNumOrd > 0 && numOrd == 1) {
                        loadNum = +loadNum + 1;
                        numOrd = 1;
                    }

                    if (numOrd > 1) {
                        hrs = 0.5;
                        eta = startTime
                            .add(hrs, 'hours')
                            .format('YYYY-MM-DD HH:mm:ss');
                    } else {
                        hrs = 3;
                        // this.shiftOrders[driverIndex][num].StandardHours[0]
                        //     .stHrs * 2;
                        eta = startTime
                            .add(hrs, 'hours')
                            .format('YYYY-MM-DD HH:mm:ss');
                    }
                    if (this.shiftOrders[driverIndex][num].RTTime > eta) {
                        rt = moment(this.shiftOrders[driverIndex][num].RTTime);
                        d1 = moment.duration(rt.diff(eta));
                        gp = d1.asHours().toFixed(2) * 1;
                    } else if (
                        this.shiftOrders[driverIndex][num].ROTime < eta
                    ) {
                        ro = moment(this.shiftOrders[driverIndex][num].ROTime);
                        d2 = moment.duration(ro.diff(eta));
                        gp = d2.asHours().toFixed(2) * 1;
                    }

                    order_values = {
                        LoadNum: loadNum,
                        LoadNumOrd: numOrd,
                        ETATime: eta,
                        GoalPost: gp
                    };
                    await axios
                        .put(
                            'order/' +
                            this.shiftOrders[driverIndex][num].OrderID,
                            order_values,
                            {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            }
                        )
                        // eslint-disable-next-line no-unused-vars
                        .then(response => {
                            console.log('Success!');

                            console.log('await');
                        })
                        .catch(function (error) {
                            console.log(error);

                            this.$store.state.isLoading = false;
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                    this.shiftOrders[driverIndex][num].LoadNum = loadNum;
                    this.shiftOrders[driverIndex][num].LoadNumOrd = numOrd;
                    this.shiftOrders[driverIndex][num].GoalPost = gp;
                }
            }

            await this.loadOrderShift(
                this.shifts[driverIndex].ShiftDetail,
                driverIndex,
                'updateFor'
            );
            await this.updateActiveOrder(
                this.shifts[driverIndex].ShiftDetail,
                driverIndex
            );

            console.log('end');
            // this.$store.state.isLoading = false;
        },
        updateForOnlyChange: async function (driverIndex) {
            //  this.$store.state.isLoading = true;

            this.shifts[driverIndex].View = false;
            console.log('uppdateLoadOrder', driverIndex);
            console.log(this.shifts);
            var startTime = moment(this.shifts[driverIndex].ShiftStartTime);
            var grpLoadNum = 1;
            var numOrd = 0;
            var loadNum = 0;
            var hrs = 0;
            var eta = null;
            var order_values = {};
            var gp = 0;
            // var split = true;
            var grp = 0;
            var grp = 0;
            var d1,
                d2,
                rt,
                ro = 0;
            console.log(this.shiftOrders[driverIndex]);
            for (const num in this.shiftOrders[driverIndex]) {
                if (this.shiftOrders[driverIndex][num].LoadNumOrd == null) {
                    // split = true;
                    hrs = 3;
                    //this.shiftOrders[driverIndex][num].StandardHours[0]
                    //    .stHrs * 2;
                    eta = startTime
                        .add(hrs, 'hours')
                        .format('YYYY-MM-DD HH:mm:ss');
                    if (this.shiftOrders[driverIndex][num].RTTime > eta) {
                        rt = moment(this.shiftOrders[driverIndex][num].RTTime);
                        d1 = moment.duration(rt.diff(eta));
                        gp = d1.asHours().toFixed(2) * 1;
                    } else if (
                        this.shiftOrders[driverIndex][num].ROTime < eta
                    ) {
                        ro = moment(this.shiftOrders[driverIndex][num].ROTime);
                        d2 = moment.duration(ro.diff(eta));
                        gp = d2.asHours().toFixed(2) * 1;
                    }
                    numOrd = 0;
                    loadNum = +loadNum + 1;
                    order_values = {
                        LoadNum: loadNum,
                        LoadNumOrd: null,
                        ETATime: eta,
                        GoalPost: gp
                    };
                    var str = this.$store;
                    await axios
                        .put(
                            'order/' +
                            this.shiftOrders[driverIndex][num].OrderID,
                            order_values,
                            {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            }
                        )
                        // eslint-disable-next-line no-unused-vars
                        .then(response => {
                            console.log('Success! uppdateLoadOrder');
                            console.log('await');
                        })
                        .catch(function (error) {
                            str.state.isLoading = false;
                            console.log(error);
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                    this.shiftOrders[driverIndex][num].LoadNum = loadNum;
                    this.shiftOrders[driverIndex][num].GoalPost = gp;
                } else {
                    grpLoadNum = this.shiftOrders[driverIndex][num].LoadNum;
                    var grpLoadNumOrd = this.shiftOrders[driverIndex][num]
                        .LoadNumOrd;
                    numOrd = +numOrd + 1;

                    console.log('loadNum', loadNum);
                    console.log('groupNum', grpLoadNum);

                    if (grpLoadNum == grp) {
                    if (grpLoadNum == grp) {
                        // loadNum = +loadNum + 1;
                        //   numOrd = 1;
                    } else {
                        grp = grpLoadNum;
                        loadNum = loadNum + 1;
                        numOrd = 1;
                    }
                    }
                    // if (grpLoadNum != loadNum) {
                    //     loadNum = +loadNum + 1;
                    //     numOrd = 1;
                    // } else if (grpLoadNumOrd > 0 && numOrd == 1) {
                    //     loadNum = +loadNum + 1;
                    //     numOrd = 1;
                    // }


                    if (numOrd > 1) {
                        hrs = 0.5;
                        eta = startTime
                            .add(hrs, 'hours')
                            .format('YYYY-MM-DD HH:mm:ss');
                    } else {
                        hrs = 3;
                        // this.shiftOrders[driverIndex][num].StandardHours[0]
                        //     .stHrs * 2;
                        eta = startTime
                            .add(hrs, 'hours')
                            .format('YYYY-MM-DD HH:mm:ss');
                    }
                    if (this.shiftOrders[driverIndex][num].RTTime > eta) {
                        rt = moment(this.shiftOrders[driverIndex][num].RTTime);
                        d1 = moment.duration(rt.diff(eta));
                        gp = d1.asHours().toFixed(2) * 1;
                    } else if (
                        this.shiftOrders[driverIndex][num].ROTime < eta
                    ) {
                        ro = moment(this.shiftOrders[driverIndex][num].ROTime);
                        d2 = moment.duration(ro.diff(eta));
                        gp = d2.asHours().toFixed(2) * 1;
                    }

                    order_values = {
                        LoadNum: loadNum,
                        LoadNumOrd: numOrd,
                        ETATime: eta,
                        GoalPost: gp
                    };
                    await axios
                        .put(
                            'order/' +
                            this.shiftOrders[driverIndex][num].OrderID,
                            order_values,
                            {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            }
                        )
                        // eslint-disable-next-line no-unused-vars
                        .then(response => {
                            console.log('Success!');

                            console.log('await');
                        })
                        .catch(function (error) {
                            console.log(error);

                            this.$store.state.isLoading = false;
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                    this.shiftOrders[driverIndex][num].LoadNum = loadNum;
                    this.shiftOrders[driverIndex][num].LoadNumOrd = numOrd;
                    this.shiftOrders[driverIndex][num].GoalPost = gp;
                }
            }
            console.log('end');
            this.changedOrder = false;
            this.changeOrd = 0;

            await this.updateActiveOrder(
                this.shifts[driverIndex].ShiftDetail,
                driverIndex,
                'updateForOnlyChange'
            );

            this.shifts[driverIndex].View = true;

            let eleosCurrent = await this.checkForEleosCurrent(
                this.shifts[driverIndex].ShiftDetail
            );
            if (
                this.shifts[driverIndex].SentMailCounter > 0 &&
                this.shifts[driverIndex].DriverEleosApp == 1 &&
                eleosCurrent == 1
            ) {
                console.log('Dentro del if');
                let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                    this.shifts[driverIndex].ShiftDetail,
                    driverIndex
                );
                await this.getCurrentShiftInfo(
                    this.shifts[driverIndex].ShiftDetail,
                    driverIndex,
                    newShiftInfoDispatch
                );
            }
            // this.$store.state.isLoading = false;
        },
        getMaxRTHrs: async function () {
            console.log(this.orders);
            let params = { Data: [] };
            for (let ord of this.orders) {
                params.Data.push({
                    OrderID: ord.OrderID,
                    StationID: ord.StationID
                });
            }

            let maxRTHrs;
            await axios
                .put('order/active/rthrs', params)
                .then(response => {
                    console.log(response.data);
                    maxRTHrs = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

            return maxRTHrs;
        },
        caculateNewROHrs: function (prd) {
            let newROHrs =
                Math.round(Number(prd.Quantity) / Number(prd.AvgDaily)) * 24;
            prd.NewROHrs = newROHrs + prd.ROHrs;
            return prd.NewROHrs;
        },
        caculateRTHrs: function (item) {
            var SafefillQty = parseInt(item.Quantity) - parseInt(item.Ullage);
            if (SafefillQty < 0) {
                item.RTHrs = 0;
            } else {
                item.RTHrs = Math.round(SafefillQty / (item.AvgDaily / 18));
            }

            return item.RTHrs;
        },
        calculateQtyByProduct: function (prd, maxLoad, thereIsREG) {
            // Check the ullage to set the temporal Quantity
            let tempQuantity = Math.floor(Number(prd.Ullage) / 1000) * 1000;
            prd.Quantity = tempQuantity;
            prd.RTHrs = this.caculateRTHrs(prd);
            prd.NewROHrs = this.caculateNewROHrs(prd);

            // Re adjusts the quantity depending on the future ullage
            let futureUllage =
                (Number(prd.AvgDaily) / 24) * prd.RTHrs + Number(prd.Ullage);
            console.log(futureUllage);
            while (futureUllage > prd.Quantity) {
                prd.Quantity += 1000;
                prd.RTHrs = this.caculateRTHrs(prd);
                prd.NewROHrs = this.caculateNewROHrs(prd);
                futureUllage =
                    (Number(prd.AvgDaily) / 24) * prd.RTHrs +
                    Number(prd.Ullage);

                if (futureUllage > prd.Quantity) {
                    console.log(futureUllage, prd.Quantity);
                    continue;
                } else {
                    prd.Quantity -= 1000;
                    prd.RTHrs = this.caculateRTHrs(prd);
                    prd.NewROHrs = this.caculateNewROHrs(prd);
                    console.log(futureUllage, prd.Quantity);
                    break;
                }
            }

            // Check RT Hrs to to increase the quantity if possible
            /*while (prd.RTHrs < 12 && prd.ROHrs >= prd.RTHrs+3) {
                prd.Quantity += 2000;
                prd.RTHrs = this.caculateRTHrs(prd);
                prd.NewROHrs = this.caculateNewROHrs(prd);

                if (prd.RTHrs < 12 && prd.ROHrs >= prd.RTHrs+3) {
                    console.log(prd.RTHrs, prd.ROHrs);
                    continue;
                } else {
                    prd.Quantity -= 2000;
                    prd.RTHrs = this.caculateRTHrs(prd);
                    prd.NewROHrs = this.caculateNewROHrs(prd);
                    console.log(prd.RTHrs, prd.ROHrs);
                    break;
                }
            }*/
            while (prd.RTHrs > prd.ROHrs - 3) {
                prd.Quantity -= 1000;
                prd.RTHrs = this.caculateRTHrs(prd);
                prd.NewROHrs = this.caculateNewROHrs(prd);

                if (prd.RTHrs > prd.ROHrs - 3) {
                    console.log(prd.RTHrs, prd.ROHrs);
                    continue;
                } else {
                    /*prd.Quantity += 1000;
                    prd.RTHrs = this.caculateRTHrs(prd);
                    prd.NewROHrs = this.caculateNewROHrs(prd);*/
                    console.log(prd.RTHrs, prd.ROHrs);
                    break;
                }
            }

            if (prd.OffProduct == 1 && prd.Quantity > 15000 && thereIsREG) {
                prd.Quantity = 15000;
                prd.RTHrs = this.caculateRTHrs(prd);
                prd.NewROHrs = this.caculateNewROHrs(prd);
            }

            // Max 47k for LSD in Quad and 50k in B Train
            if (prd.MaxCap == 1) {
                // The product is some type of LSD
                if (maxLoad == 54000 && prd.Quantity > 47000) {
                    // Adjust the quantity
                    prd.Quantity = Math.floor(47000 / 1000) * 1000;
                    prd.RTHrs = this.caculateRTHrs(prd);
                    prd.NewROHrs = this.caculateNewROHrs(prd);
                } else if (maxLoad == 58000 && prd.Quantity > 50000) {
                    // Adjust the quantity
                    prd.Quantity = Math.floor(50000 / 1000) * 1000;
                    prd.RTHrs = this.caculateRTHrs(prd);
                    prd.NewROHrs = this.caculateNewROHrs(prd);
                }
            }

            console.log(prd);
            return prd;
        },
        sortItemsByFactor: function (items, factor, sort) {
            // Bubble sorting to sort items by factor
            let l = items.length;
            let aux;
            for (let i = 1; i < l; i++) {
                for (let r = 0; r < l - i; r++) {
                    if (sort == 'asc') {
                        if (items[r][factor] > items[r + 1][factor]) {
                            aux = items[r];
                            items[r] = items[r + 1];
                            items[r + 1] = aux;
                        }
                    } else if (sort == 'desc') {
                        if (items[r][factor] < items[r + 1][factor]) {
                            aux = items[r];
                            items[r] = items[r + 1];
                            items[r + 1] = aux;
                        }
                    }
                }
            }
            return items;
        },
        calculateGasQty: function (prds) {
            // Check if there is LSD product to Dispatch and calculate the gasQty
            let dieselPrds = prds.filter(prd => prd.MaxCap == 1);
            dieselPrds = this.sortItemsByFactor(dieselPrds, 'Quantity', 'desc');
            let gasQty = 0;
            if (dieselPrds.length >= 1) {
                gasQty = dieselPrds[0].Quantity * 1.14;
            }
            /*for (let prd of prds) {
                // Check the ullage to set the temporal Quantity
                let searchLSD = prd.Product.search("LSD");
                console.log(searchLSD);
                if (searchLSD != -1) {
                    // The product is some type of LSD
                    // Calculate gas quantity with factor 1.14
                    gasQty = prd.Quantity * 1.14;
                    break;
                }
            }*/
            return gasQty;
        },
        updateFromCurrentReadings: function (orderID) {
            console.log(orderID);
            axios
                .put(
                    'ftp-readings/update/last-order-dispatched/' + orderID,
                    '',
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    console.log(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        setQuantities: function (data, order, shDet, index) {
            var str = this.$store;
            console.log(data, order);

            // Set the Max Load depends Quad or Big Train
            let maxLoad = 0;
            if (data.QuadCall == 1) {
                // Is Quad
                maxLoad = 54000;
            } else {
                maxLoad = 58000;
            }
            console.log('maxLoad', maxLoad);

            // Calculate the priority of each product (high/low) depends the RO Time
            for (let prd of data.OrderDetails) {
                if (prd.ROHrs <= 24) {
                    // High priority
                    prd.Priority = 'high';
                } else {
                    // Low priority
                    prd.Priority = 'low';
                }
            }

            // Check if there is high priority products
            let highPrds = data.OrderDetails.filter(
                pr => pr.Priority == 'high'
            );
            if (highPrds.length != 0) {
                highPrds = this.sortItemsByFactor(highPrds, 'ROHrs', 'asc');
                console.log('highPrds sorted by lowest RO: ', highPrds);
            } else {
                console.log('highPrds sorted by lowest RO: ', highPrds);
                for (let prd of data.OrderDetails) {
                    prd.Priority = 'high';
                }
                highPrds = data.OrderDetails.filter(
                    pr => pr.Priority == 'high'
                );
                highPrds = this.sortItemsByFactor(highPrds, 'Ullage', 'desc');
            }

            // Calculate Quantity for each high priority product the first time
            let thereIsREG = false;
            for (let prd of highPrds) {
                let searchREG = prd.Product.search('REG');
                if (searchREG != -1) {
                    // There is EREG
                    thereIsREG = true;
                    break;
                }
            }
            for (let prd of highPrds) {
                prd = this.calculateQtyByProduct(prd, maxLoad, thereIsREG);
            }
            console.log(highPrds);

            // ------------------- Secure the next load for low priority products -------------------
            let lowPrds = data.OrderDetails.filter(pr => pr.Priority == 'low');
            if (lowPrds.length != 0) {
                lowPrds = this.sortItemsByFactor(lowPrds, 'ROHrs', 'asc');
            }
            console.log('lowPrds sorted by lowest RO: ', lowPrds);

            // Check if the higher ROHrs from the dispatch products is greater than
            // the ROHrs from the off products to add it to the current load or not
            highPrds = this.sortItemsByFactor(highPrds, 'NewROHrs', 'desc');
            let prdHigherROHrs = highPrds[0];
            for (let prd of lowPrds) {
                if (prdHigherROHrs.NewROHrs > prd.ROHrs) {
                    // Mark as high priority
                    console.log('Mark as new-high priority');
                    prd.Priority = 'new-high';
                    break;
                }
                // Else - Ignore in the current dispatch
            }

            // Merge both arrays (high and new high) if needed
            let newHighPrds = lowPrds.filter(prd => prd.Priority == 'new-high');
            let endHighPrds;
            console.log(newHighPrds, lowPrds);
            if (newHighPrds.length != 0) {
                newHighPrds = this.sortItemsByFactor(
                    newHighPrds,
                    'ROHrs',
                    'asc'
                );
                endHighPrds = highPrds.concat(newHighPrds);
                console.log(endHighPrds);
            } else {
                endHighPrds = highPrds;
            }

            // Re - Calculate Quantity for each new-high and high priority product
            thereIsREG = false;
            for (let prd of endHighPrds) {
                let searchREG = prd.Product.search('REG');
                if (searchREG != -1) {
                    // There is EREG
                    thereIsREG = true;
                    break;
                }
            }
            for (let prd of endHighPrds) {
                prd = this.calculateQtyByProduct(prd, maxLoad, thereIsREG);
            }

            // Check if there is LSD product to Dispatch and calculate the gasQty
            let gasQty = this.calculateGasQty(endHighPrds);
            if (gasQty != 0 && thereIsREG) {
                // Verify Gas Qty
                let sumGasQty = 0;
                for (let prd of endHighPrds) {
                    let searchPREM = prd.Product.search('PREM');
                    let searchREG = prd.Product.search('REG');
                    let searchULTRA = prd.Product.search('ULTRA');

                    if (
                        searchPREM != -1 ||
                        searchREG != -1 ||
                        searchULTRA != -1
                    ) {
                        sumGasQty += prd.Quantity;
                    }
                }

                if (maxLoad == 54000) {
                    let maxQtyToLoad = 54000 - gasQty;

                    while (sumGasQty > maxQtyToLoad) {
                        sumGasQty = 0;
                        for (let prd of endHighPrds) {
                            let searchPREM = prd.Product.search('PREM');
                            let searchREG = prd.Product.search('REG');
                            let searchULTRA = prd.Product.search('ULTRA');

                            if (searchREG != -1) {
                                prd.Quantity -= 1000;
                                prd.RTHrs = this.caculateRTHrs(prd);
                                prd.NewROHrs = this.caculateNewROHrs(prd);
                            }

                            if (
                                searchPREM != -1 ||
                                searchREG != -1 ||
                                searchULTRA != -1
                            ) {
                                sumGasQty += prd.Quantity;
                            }
                        }
                        console.log(sumGasQty);
                    }
                } else if (maxLoad == 58000) {
                    let maxQtyToLoad = 58000 - gasQty;

                    while (sumGasQty > maxQtyToLoad) {
                        sumGasQty = 0;
                        for (let prd of endHighPrds) {
                            let searchPREM = prd.Product.search('PREM');
                            let searchREG = prd.Product.search('REG');
                            let searchULTRA = prd.Product.search('ULTRA');

                            if (searchREG != -1) {
                                prd.Quantity -= 1000;
                                prd.RTHrs = this.caculateRTHrs(prd);
                                prd.NewROHrs = this.caculateNewROHrs(prd);
                            }

                            if (
                                searchPREM != -1 ||
                                searchREG != -1 ||
                                searchULTRA != -1
                            ) {
                                sumGasQty += prd.Quantity;
                            }
                        }
                        console.log(sumGasQty);
                    }
                }
            }

            let sumQtys = 0;
            let newLowPrds = lowPrds.filter(prd => prd.Priority == 'low');
            endHighPrds = this.sortItemsByFactor(
                endHighPrds,
                'Quantity',
                'desc'
            );
            console.log(newLowPrds);
            for (let prd of endHighPrds) {
                sumQtys += prd.Quantity;
            }
            if (sumQtys > maxLoad) {
                // Check that it does not exceed max load
                let diff = sumQtys - maxLoad;
                endHighPrds[0].Quantity -= diff;
                endHighPrds[0].RTHrs = this.caculateRTHrs(endHighPrds[0]);
                endHighPrds[0].NewROHrs = this.caculateNewROHrs(endHighPrds[0]);
            } else if (sumQtys < maxLoad) {
                // Ensure full load if possible
                if (newLowPrds.length != 0) {
                    let diff = maxLoad - sumQtys;
                    newLowPrds = this.sortItemsByFactor(
                        newLowPrds,
                        'ROHrs',
                        'asc'
                    );
                    console.log(newLowPrds);
                    let lowPrdWithLessROHrs = this.calculateQtyByProduct(
                        newLowPrds[0],
                        maxLoad,
                        thereIsREG
                    );
                    console.log(lowPrdWithLessROHrs, diff);
                    if (lowPrdWithLessROHrs.Quantity >= diff) {
                        lowPrdWithLessROHrs.Quantity = diff;
                        lowPrdWithLessROHrs.RTHrs = this.caculateRTHrs(
                            lowPrdWithLessROHrs
                        );
                        lowPrdWithLessROHrs.NewROHrs = this.caculateNewROHrs(
                            lowPrdWithLessROHrs
                        );
                        lowPrdWithLessROHrs.Priority = 'high';
                        newLowPrds[0].Priority = 'high';
                        endHighPrds.push(lowPrdWithLessROHrs);
                        console.log(endHighPrds);
                    } else if (
                        lowPrdWithLessROHrs.Quantity < diff &&
                        lowPrdWithLessROHrs.Quantity > 2000
                    ) {
                        lowPrdWithLessROHrs.Priority = 'high';
                        newLowPrds[0].Priority = 'high';
                        endHighPrds.push(lowPrdWithLessROHrs);
                    }
                }
            }

            // Max 47k for LSD in Quad and 50k in B Train
            let dieselPrds = endHighPrds.filter(prd => prd.MaxCap == 1);
            if (dieselPrds.length >= 1) {
                let sumMaxCapLSD = 0;
                for (let prd of dieselPrds) {
                    sumMaxCapLSD += prd.Quantity;
                }
                while (maxLoad == 54000 && sumMaxCapLSD > 47000) {
                    // Deleted the LSD product with less Qty
                    dieselPrds = this.sortItemsByFactor(
                        dieselPrds,
                        'Quantity',
                        'asc'
                    );
                    dieselPrds[0].Priority = 'low';
                    newLowPrds.push(dieselPrds[0]);
                    dieselPrds.shift();
                    let sumMaxCapLSD = 0;
                    for (let prd of dieselPrds) {
                        sumMaxCapLSD += prd.Quantity;
                    }
                    console.log(sumMaxCapLSD);
                    if (sumMaxCapLSD <= 47000) {
                        break;
                    }
                }
                while (maxLoad == 58000 && sumMaxCapLSD > 50000) {
                    // Deleted the LSD product with less Qty
                    dieselPrds = this.sortItemsByFactor(
                        dieselPrds,
                        'Quantity',
                        'asc'
                    );
                    dieselPrds[0].Priority = 'low';
                    newLowPrds.push(dieselPrds[0]);
                    dieselPrds.shift();
                    let sumMaxCapLSD = 0;
                    for (let prd of dieselPrds) {
                        sumMaxCapLSD += prd.Quantity;
                    }
                    console.log(sumMaxCapLSD);
                    if (sumMaxCapLSD <= 50000) {
                        break;
                    }
                }
            }

            // Update High Priority Products
            for (let high of endHighPrds) {
                for (let low of newLowPrds) {
                    if (high.ProductID == low.ProductID) {
                        let index = endHighPrds.indexOf(high);
                        if (index > -1) {
                            endHighPrds.splice(index, 1);
                        }
                    }
                }
            }

            // Update Low Priority Products
            for (let high of endHighPrds) {
                if (high.Quantity < 2000) {
                    high.Priority = 'low';
                    newLowPrds.push(high);
                }
            }
            endHighPrds = endHighPrds.filter(prd => prd.Priority == 'high');

            // Short load alert if applied
            let isShortLoad = false;
            endHighPrds = this.sortItemsByFactor(
                endHighPrds,
                'Quantity',
                'desc'
            );
            sumQtys = 0;
            for (let prd of endHighPrds) {
                sumQtys += prd.Quantity;
            }
            if (sumQtys < maxLoad) {
                str.dispatch('setSnackbar', {
                    color: 'warning',
                    text: 'The order ' + order + ' is a Short Load.'
                });
                isShortLoad = true;
            }

            // Update Short Load
            this.setShortLoad(order, isShortLoad, shDet, index);

            // Update Order Details
            newLowPrds = newLowPrds.filter(prd => prd.Priority == 'low');
            console.log(endHighPrds);
            console.log(newLowPrds);
            this.updateOrderDetails(endHighPrds, newLowPrds, order);
        },
        setShortLoad: async function (order, isShortLoad, shDet, index) {
            let params = {
                OrderID: order,
                IsShortLoad: isShortLoad
            };
            await axios
                .put('order/short-load/update', params)
                .then(response => {
                    console.log(response.data);
                    this.loadOrderShift(shDet, index, 'setShortLoad');
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        updateOrderDetails: function (highPrds, lowPrds, order) {
            var str = this.$store;
            console.log(highPrds, lowPrds, order);
            let params = {
                OrderID: order,
                HighPrds: [],
                LowPrds: []
            };

            for (let prd of highPrds) {
                params.HighPrds.push({
                    ProductID: prd.ProductID,
                    Quantity: prd.Quantity
                });
            }

            for (let prd of lowPrds) {
                params.LowPrds.push(prd.ProductID);
            }

            console.log(params);
            axios
                .put('order-detail/order/update', params)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text:
                            'Quantities were successfully updated for the Order ' +
                            order +
                            '.'
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        assignLoad: async function (order, status, shift, edit, index, ROHrs) {
            this.$store.state.isLoading = true;
            console.log('assignLoad', order, status, shift, edit, index, ROHrs);
            var str = this.$store;

            // Consult the shift origin for the order
            let data = {
                OrderIDs: [order],
                ShiftDetail: shift.ShiftDetail
            };
            let origins = {};
            await axios
                .post('shift-detail/order-origin', data, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(function (response) {
                    //console.log("response->", response.data);
                    origins = response.data;
                })
                .catch(error => {
                    console.log(error);
                });

            console.log('Origins: ', origins);
            let originsData = origins[order];
            console.log(originsData);
            let unknownOrigins = '';
            if (originsData.length != 0) {
                if (originsData[0].ShiftDetail == shift.ShiftDetail) {
                    unknownOrigins = '';
                } else {
                    unknownOrigins =
                        originsData[0].DriverName +
                        ' / ' +
                        originsData[0].Date +
                        ' ' +
                        originsData[0].Shift;
                }
            }

            var order_values = {
                OrderStatus: 'DISPATCHED',
                ShiftDetail: shift.ShiftDetail,
                OrdLoadStatus: 'READYTOSEND',
                UnknownOrigins: unknownOrigins,
                QuadCall: shift.QuadCall,
                PumpCall: shift.PumpCall,
                ROHrs: ROHrs
            };

            console.log(this.shiftOrders[index]);

            if (shift.SentMailCounter >= 1) {
                await axios
                    .get('order/check/load-status/' + order, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        let orderData = response.data[0];
                        if (orderData.ShiftDetail == shift.ShiftDetail) {
                            order_values.OrdLoadStatus =
                                orderData.LoadStatus == 'DISPATCHED' ||
                                    orderData.LoadStatus == 'PRLDISPAT' ||
                                    orderData.LoadStatus == 'PRELOAD'
                                    ? 'NOTSTARTED'
                                    : orderData.LoadStatus;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }

            console.log(order_values);

            if (
                status == 'PRLDHELD' ||
                status == 'PRLDISPAT' ||
                status == 'PRELOAD'
            ) {
                axios
                    .get(
                        'order/check/preload/' + shift.TrailerID + '/' + order,
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    )
                    .then(response => {
                        if (response.data.length == 0) {
                            str.dispatch('setSnackbar', {
                                color: 'danger',
                                text: 'This trailer does not match the preload!'
                            });

                            this.shiftOrders[edit].splice(index, 1);
                            this.recall(false);
                        } else {
                            order_values.OrderStatus = 'PRLDISPAT';
                            console.log('status', order_values);
                            axios
                                .put(
                                    'order/assing/load/' + order,
                                    order_values,
                                    {
                                        headers: {
                                            Authorization:
                                                'Bearer ' +
                                                this.$store.state.token
                                        }
                                    }
                                )
                                // eslint-disable-next-line no-unused-vars
                                .then(response => {
                                    console.log('Success Assign!');
                                    console.log(response.data);
                                    // Update locally
                                    this.shiftOrders[edit][index].ShiftDetail =
                                        shift.ShiftDetail;
                                    this.advice(
                                        response.data.Data.original.Station,
                                        response.data.Data.original.Terminal,
                                        response.data.Data.original.OrderID
                                    );
                                    if (response.data.AutomaticCreation == 1) {
                                        this.setQuantities(
                                            response.data.Qtys,
                                            order,
                                            shift.ShiftDetail,
                                            index
                                        );
                                        //this.updateFromCurrentReadings(order);
                                    }
                                    this.updateLoadOrder(edit);
                                    this.loadShifts();
                                })
                                .catch(function (error) {
                                    this.$store.state.isLoading = false;
                                    console.log(error);
                                    if (error.response.status === 403) {
                                        str.dispatch('setSnackbar', {
                                            color: 'error',
                                            text:
                                                'You do not have the permission to use this function.'
                                        });
                                    }
                                    if (error.response.status === 500) {
                                        str.dispatch('setSnackbar', {
                                            color: 'error',
                                            text:
                                                'An error has ocurred, please try again.'
                                        });
                                    }
                                });
                        }
                    })
                    .catch(function (error) {
                        this.$store.state.isLoading = false;
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            } else {
                console.log('status', order_values);

                axios
                    .put('order/assing/load/' + order, order_values, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    // eslint-disable-next-line no-unused-vars
                    .then(async response => {
                        console.log('Success Assign!');
                        console.log(response.data);
                        this.advice(
                            response.data.Data.original.Station,
                            response.data.Data.original.Terminal,
                            response.data.Data.original.OrderID
                        );

                        // Update locally
                        this.shiftOrders[edit][index].ShiftDetail =
                            shift.ShiftDetail;

                        if (response.data.AutomaticCreation == 1) {
                            this.setQuantities(
                                response.data.Qtys,
                                order,
                                shift.ShiftDetail,
                                index
                            );
                            //this.updateFromCurrentReadings(order);
                        }
                        await this.filterOrd();
                        await this.updateLoadOrder(edit);
                    })
                    .catch(function (error) {
                        str.state.isLoading = false;
                        console.log(error);
                    });
            }
            this.filterOrd();
            this.$store.state.isLoading = false;
        },
        de_assignLoad: function (order, status) {
            this.$store.state.isLoading = true;
            console.log('de-assignLoad', order, status);
            var str = this.$store;
            var order_values = {
                OrderStatus: 'ACTIVE',
                OrdLoadStatus: 'READYTOSEND',
                ShiftDetail: 0,
                LoadNum: null,
                LoadNumOrd: null
            };
            if (status == 'PRLDISPAT') {
                order_values.OrderStatus = 'PRLDHELD';
            }
            axios
                .put('order/des/assing/load/' + order, order_values)
                // eslint-disable-next-line no-unused-vars
                .then(async response => {
                    console.log('Success! de_assignLoad');
                    await this.updateFor(this.idxRemv);
                    this.recall(true);
                })
                .catch(function (error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        remove: function (evt) {
            this.toOrder = 1;
            const realIndex = this.orders.indexOf(
                this.orders.find(
                    ({ OrderID }) =>
                        OrderID === this.filteredOrders[evt.oldIndex].OrderID
                )
            );
            this.orders.splice(realIndex, 1);
        },
        advice: function (station, terminal, order) {
            var str = this.$store;
            var parms = {
                terminalID: terminal,
                stationID: station
            };
            console.log(parms);
            axios
                .post('station-advice/advice', parms)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log(response.data);
                    if (
                        response.data.stationDT.length > 0 ||
                        response.data.terinalDT.length > 0
                    ) {
                        this.orderN = order;
                        this.adviceText = response.data;
                        str.state.dispatch.adviceDlg = true;
                    }
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadOrderShift: async function (
            shiftDetail,
            index,
            invocationOrigin = ''
        ) {
            this.shifts[index].View = false;
            this.shiftOrders[index].length = 0;
            await axios
                .get('order/shift/' + shiftDetail)
                .then(async response => {
                    console.log(response.data);
                    this.shiftOrders[index] = response.data;

                    if (
                        invocationOrigin != 'updateActiveOrder' ||
                        invocationOrigin !=
                        'onFinalizeCurrentOrderInProgressClose' ||
                        invocationOrigin != 'endOrder' ||
                        invocationOrigin != 'onEditOrderClose' ||
                        invocationOrigin != 'onPreloadOrderToShiftClose' ||
                        invocationOrigin != 'onShiftSummaryClose' ||
                        invocationOrigin != 'preloadOrderInterface' ||
                        invocationOrigin != 'unpreloadOrderInterface' ||
                        invocationOrigin != 'updateFor' ||
                        invocationOrigin != 'setShortLoad'
                    ) {
                        this.AlterOrders = false;
                        this.idxAdd = 0;
                        this.idxRemv = 0;
                    }

                    this.shifts[index].View = true;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadOrderToOrder: function (shiftDetail, index) {
            this.shifts[index].View = false;
            this.shiftOrders[index].length = 0;
            axios
                .get('order/shift/' + shiftDetail)
                .then(response => {
                    console.log(response.data);
                    this.shiftOrders[index] = response.data;
                    this.AlterOrders = false;
                    this.shifts[index].View = true;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        checkCurrentOrderInProgress: async function (shift, index) {
            var str = this.$store;
            let eleosCurrent = await this.checkForEleosCurrent(
                shift.ShiftDetail
            );

            if (this.shiftOrders[index].length == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This Shift has no orders.'
                });
                return;
            } else if (
                shift.SentMailCounter == 0 ||
                shift.SentMailCounter == null
            ) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This Shift has no mailings yet.'
                });
                return;
            } else if (eleosCurrent == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This Shift no longer exists in Eleos.'
                });
                return;
            }

            console.log(shift, index);
            str.state.isLoading = true;
            await axios
                .get('shift-detail/eleos-current-loads/' + shift.ShiftDetail)
                .then(response => {
                    console.log(response.data);
                    this.ordersToBeEvaluated = response.data;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });

            let shiftDetail = shift.ShiftDetail;
            let isSynchronized = await this.checkSyncPlatforms(
                shiftDetail,
                'not-apply',
                'tools'
            );

            if (isSynchronized) {
                for (
                    let ord = 0;
                    ord < this.ordersToBeEvaluated.length;
                    ord++
                ) {
                    if (this.ordersToBeEvaluated[ord].ActiveOrder == 1) {
                        console.log(
                            'El shift detail seleccionado sí tiene una orden actualmente activa'
                        );
                        this.shiftForcedCompletion = shift.ShiftDetail;
                        console.log(this.ordersToBeEvaluated);
                        this.$store.state.dispatch.finalizeCurrentOrderInProgress = true;
                        break;
                    } else if (ord === this.ordersToBeEvaluated.length - 1) {
                        console.log(
                            'El shift detail no tiene ninguna orden actualmente activa.'
                        );
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'The selected shift has no active orders.'
                        });
                        return;
                    }
                }
            }
        },
        multiPreloadOrderActiveInterface: async function (shiftDetail, index) {
            var str = this.$store;
            this.multiPreloadsCheck = {};
            console.log(this.multiPreloadsCheck);

            if (this.multiPreloads[shiftDetail]) {
                this.multiPreloads[shiftDetail] = false;
                this.shifts[index].ColorMultiPreloadBtn = '#4f83cc';
            } else {
                if (this.AlterOrders) {
                    this.shifts[index].View = false;
                    this.shiftOrders[index].length = 0;
                    axios
                        .get('order/shift/' + shiftDetail, {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        })
                        .then(response => {
                            console.log(response.data);
                            this.shiftOrders[index] = response.data;
                            this.AlterOrders = false;
                            this.shifts[index].View = true;
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
                for (let ord = 0; ord < this.shiftOrders[index].length; ord++) {
                    if (
                        this.shiftOrders[index][ord].OrderStatus ===
                        'DISPATCHED' &&
                        this.shiftOrders[index][ord].OrdLoadStatus !== 'DONE' &&
                        this.shiftOrders[index][ord].OrdLoadStatus !==
                        'FORCEDCOMPLETION'
                    ) {
                        console.log(
                            'El shift detail seleccionado sí tiene ordenes aptas para PRELOAD'
                        );
                        this.shiftOrdersToPreload = this.shiftOrders[index];
                        console.log(this.shiftOrdersToPreload);
                        break;
                    } else if (ord === this.shiftOrders[index].length - 1) {
                        console.log(
                            'El shift detail no tiene ordenes aptas para PRELOAD'
                        );
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'The selected shift detail does not have orders suitable for PRELOAD.'
                        });
                        return;
                    }
                }
                for (let shDet in this.multiPreloads) {
                    this.multiPreloads[shDet] = false;
                }
                this.multiPreloads[shiftDetail] = true;

                for (let sh of this.shifts) {
                    sh.ColorMultiPreloadBtn = '#4f83cc';
                }
                this.shifts[index].ColorMultiPreloadBtn = 'green';
                console.log(this.shifts[index]);
                // console.log(this.shiftOrders)
            }
        },
        multiPreloadOrderActive: async function (shiftDetail, index) {
            var str = this.$store;
            if (this.shiftOrders[index].length == 0) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This Shift has no orders.'
                });
                return;
            }

            let shift = this.shifts[index];

            if (shift.DriverEleosApp == 1) {
                let isSynchronized = await this.checkSyncPlatforms(
                    shiftDetail,
                    'not-apply',
                    'tools'
                );
                if (isSynchronized) {
                    await this.multiPreloadOrderActiveInterface(
                        shiftDetail,
                        index
                    );
                }
            } else {
                await this.multiPreloadOrderActiveInterface(shiftDetail, index);
            }
        },
        multiPreloadOrder: function (ordersObj) {
            // Valida que el usuario haya seleccionado al menos una orden
            if (!Object.keys(ordersObj).length) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'You have to select at least one order.'
                });
                return;
            }

            // Filtra las ordenes que tienen el checkbox en true y las almacena en un arreglo
            // let str = this.$store;
            let ordersArr = [];

            for (let ordID in ordersObj) {
                if (ordersObj[ordID]) {
                    ordersArr.push(ordID);
                }
            }

            console.log(ordersArr);

            // Actualiza shiftOrdersToPreload (almacena los objetos de las ordenes seleccionadas para asignación)
            let ordersToAssign = [];

            for (let ord of this.shiftOrdersToPreload) {
                for (let ordID of ordersArr) {
                    if (ord.OrderID == ordID) {
                        ordersToAssign.push(ord);
                    }
                }
            }

            console.log(ordersToAssign);
            if (!ordersToAssign.length) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'You have to select at least one order.'
                });
                return;
            }

            // Vacía el objeto original
            Object.keys(ordersObj).forEach(k => delete ordersObj[k]);

            this.ordersToShiftRequired = ordersToAssign;
            this.$store.state.dispatch.potoshift = true;

            // this.$store.state.isLoading = true;

            // for (let ordID of ordersArr) {
            //     axios
            //     .get('order/preload/' + ordID, {
            //         headers: {
            //             Authorization: 'Bearer ' + this.$store.state.token
            //         }
            //     })
            //     .then(response => {
            //         console.log(response);
            //     })
            //     .catch(function(error) {
            //         str.state.isLoading = false;
            //         console.log(error);
            //     });
            // }

            // this.loadShifts();

            // this.$store.state.isLoading = false;
        },
        preloadOrderToShiftActive: function (order) {
            console.log(order);

            var str = this.$store;
            this.ordersToShiftRequired = [];

            if (order.OrderStatus !== 'DISPATCHED') {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'The selected order is not suitable for PRELOAD.'
                });
                return;
            }

            this.ordersToShiftRequired.push(order);
            this.$store.state.dispatch.potoshift = true;
        },
        preloadOrderInterface: async function (order, index, eleosCurrent) {
            var str = this.$store;
            if (
                order.OrderStatus !== 'DISPATCHED' ||
                order.OrdLoadStatus === 'DONE' ||
                order.OrdLoadStatus === 'FORCEDCOMPLETION'
            ) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'The selected order is not suitable for PRELOAD.'
                });
                return;
            }

            this.$store.state.isLoading = true;
            console.log(order);
            // console.log('Preload Order');
            // console.log('OrderID', order.OrderID, order.ShiftDetail);
            // const shiftIndex = this.shiftDetails.indexOf(order.ShiftDetail);
            // console.log(shiftIndex);
            // const orderIndex = this.shiftOrders[shiftIndex].indexOf(
            //     this.shiftOrders[shiftIndex].find(
            //         ({ OrderID }) => OrderID === order.OrderID
            //     )
            // );

            // if (this.shiftOrders[shiftIndex].length - 1 != orderIndex) {
            //     alert('Cannot preload unless its the last load.');
            // } else {

            await axios
                .get('order/preload/' + order.OrderID)
                .then(async response => {
                    console.log(response);
                    await this.loadOrderShift(
                        this.shifts[index].ShiftDetail,
                        index,
                        'preloadOrderInterface'
                    );
                    await this.updateActiveOrder(
                        this.shifts[index].ShiftDetail,
                        index
                    );

                    if (
                        this.shifts[index].SentMailCounter > 0 &&
                        this.shifts[index].DriverEleosApp == 1 &&
                        eleosCurrent == 1
                    ) {
                        console.log('Dentro del if');
                        let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                            this.shifts[index].ShiftDetail,
                            index
                        );
                        await this.getCurrentShiftInfo(
                            this.shifts[index].ShiftDetail,
                            index,
                            newShiftInfoDispatch
                        );
                    }

                    this.loadShifts();
                })
                .catch(function (error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });

            // }
            this.$store.state.isLoading = false;
        },
        preloadOrder: async function (order) {
            let shiftDetail = order.ShiftDetail;
            let index = this.shiftDetails.indexOf(shiftDetail);
            let shift = this.shifts[index];
            let eleosCurrent = await this.checkForEleosCurrent(shiftDetail);

            if (shift.DriverEleosApp == 1) {
                let isSynchronized = await this.checkSyncPlatforms(
                    shiftDetail,
                    'not-apply',
                    'preload'
                );
                if (isSynchronized) {
                    await this.preloadOrderInterface(
                        order,
                        index,
                        eleosCurrent
                    );
                }
            } else {
                await this.preloadOrderInterface(order, index, eleosCurrent);
            }
        },
        unpreloadOrderInterface: async function (order, index, eleosCurrent) {
            var str = this.$store;
            str.isLoading = true;
            console.log('unpreload');
            console.log('OrderID', order.OrderID, order.ShiftDetail);
            // console.log('ORDER', order);
            // const shiftIndex = this.shiftDetails.indexOf(order.ShiftDetail);
            // console.log(shiftIndex);
            // const orderIndex = this.shiftOrders[shiftIndex].indexOf(
            //     this.shiftOrders[shiftIndex].find(
            //         ({ OrderID }) => OrderID === order.OrderID
            //     )
            // );
            await axios
                .get('order/unpreload/' + order.OrderID)
                .then(async response => {
                    console.log(response);
                    await this.loadOrderShift(
                        this.shifts[index].ShiftDetail,
                        index,
                        'unpreloadOrderInterface'
                    );
                    await this.updateActiveOrder(
                        this.shifts[index].ShiftDetail,
                        index
                    );

                    if (
                        this.shifts[index].SentMailCounter > 0 &&
                        this.shifts[index].DriverEleosApp == 1 &&
                        eleosCurrent == 1
                    ) {
                        console.log('Dentro del if');
                        let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                            this.shifts[index].ShiftDetail,
                            index
                        );
                        await this.getCurrentShiftInfo(
                            this.shifts[index].ShiftDetail,
                            index,
                            newShiftInfoDispatch
                        );
                    }

                    this.loadShifts();
                    str.isLoading = false;
                })
                .catch(function (error) {
                    str.isLoading = false;
                    console.log(error);
                });
        },
        checkForEleosCurrent: async function (shiftDetail) {
            let resp;
            await axios
                .get('shift-detail/eleos-current-shift/' + shiftDetail)
                .then(response => {
                    console.log('checkForEleosCurrent: ', response.data);
                    resp = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

            return resp;
        },
        unpreloadOrder: async function (order) {
            let shiftDetail = order.ShiftDetail;
            let index = this.shiftDetails.indexOf(shiftDetail);
            let shift = this.shifts[index];
            let eleosCurrent = await this.checkForEleosCurrent(shiftDetail);

            if (shift.DriverEleosApp == 1) {
                console.log('Sincronizando...');
                let isSynchronized = await this.checkSyncPlatforms(
                    shiftDetail,
                    'not-apply',
                    'un-preload'
                );
                if (isSynchronized) {
                    await this.unpreloadOrderInterface(
                        order,
                        index,
                        eleosCurrent
                    );
                }
            } else {
                console.log('No existe en Eleos');
                await this.unpreloadOrderInterface(order, index, eleosCurrent);
            }
        },
        unsplitOrderInterface: async function (order) {
            this.$store.state.isLoading = true;
            console.log('Unsplit Order');
            console.log(order);
            console.log('OrderID', order.OrderID, order.ShiftDetail);
            const shiftIndex = this.shiftDetails.indexOf(order.ShiftDetail);
            console.log(shiftIndex);
            console.log(this.shiftOrders[shiftIndex]);
            const orderIndex = this.shiftOrders[shiftIndex].indexOf(
                this.shiftOrders[shiftIndex].find(
                    ({ OrderID }) => OrderID === order.OrderID
                )
            );
            console.log(orderIndex);
            this.shiftOrders[shiftIndex][orderIndex].LoadNumOrd = null;
            this.updateForOnlyChange(shiftIndex);
            this.$store.state.isLoading = false;
        },
        unsplitOrder: async function (order) {
            let shiftDetail = order.ShiftDetail;
            let index = this.shiftDetails.indexOf(shiftDetail);
            let shift = this.shifts[index];

            if (shift.DriverEleosApp == 1) {
                let isSynchronized = await this.checkSyncPlatforms(
                    shiftDetail,
                    'not-apply',
                    'un-split'
                );
                if (isSynchronized) {
                    await this.unsplitOrderInterface(order);
                }
            } else {
                await this.unsplitOrderInterface(order);
            }
        },
        splitOrder: async function (order) {
            this.$store.state.isLoading = true;

            var str = this.$store;
            console.log('Split Order');
            console.log('OrderID', order.OrderID, order.ShiftDetail);
            const shiftIndex = this.shiftDetails.indexOf(order.ShiftDetail);
            console.log(shiftIndex);
            console.log(this.shiftOrders[shiftIndex]);
            const orderIndex = this.shiftOrders[shiftIndex].indexOf(
                this.shiftOrders[shiftIndex].find(
                    ({ OrderID }) => OrderID === order.OrderID
                )
            );
            console.log(orderIndex);
            if (orderIndex == 0) {
                // First Order, show warning
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Cannot split first order.'
                });
            } else {
                // Start split,

                // Ask for split reason

                var splitNum = null;
                var loadNum = null;
                var prevIndex = +orderIndex - 1;
                var prevOrder = this.shiftOrders[shiftIndex][prevIndex];
                console.log('PrevOrder', prevOrder);
                if (prevOrder.LoadNumOrd == null) {
                    splitNum = 1;
                } else {
                    splitNum = prevOrder.LoadNumOrd;
                }
                loadNum = this.shiftOrders[shiftIndex][prevIndex].LoadNum;

                console.log(
                    'LoadNumOrd of previous order set, move on to current'
                );
                this.shiftOrders[shiftIndex][prevIndex].LoadNumOrd = splitNum;
                splitNum = +splitNum + 1;

                console.log('Done creating split');
                this.shiftOrders[shiftIndex][orderIndex].LoadNum = loadNum;
                this.shiftOrders[shiftIndex][orderIndex].LoadNumOrd = splitNum;

                await this.updateForOnlyChange(shiftIndex);
                await this.submitSplitType(this.shiftOrders[shiftIndex][orderIndex].OrderID);
            }
            this.$store.state.isLoading = false;
        },
        submitSplitType: function (OrderID) {
            var str = this.$store;
            console.log('Submit Split Order');
            var params = {
                SplitTypeID: this.split_type.SplitTypeID
            };
            console.log(params, this.split_type.SplitTypeID);
            axios
                .put('order/' + OrderID, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.split_dialog = false;
                })
                .catch(function (error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.split_dialog = false;
        },
        openModalSplit: async function (order) {
            let shiftDetail = order.ShiftDetail;
            let index = this.shiftDetails.indexOf(shiftDetail);
            let shift = this.shifts[index];

            console.log(order);
            if (shift.DriverEleosApp == 1) {
                let isSynchronized = await this.checkSyncPlatforms(
                    shiftDetail,
                    'not-apply',
                    'split'
                );
                if (isSynchronized) {
                    // await this.loadSplitTypes();
                    this.splitOrderID = order;
                    this.split_dialog = true;
                }
            } else {
                // await this.loadSplitTypes();
                this.splitOrderID = order;
                this.split_dialog = true;
            }
        },
        toggleYard: function (yard) {
            const index = this.filteredYards.indexOf(yard);
            if (index == -1) {
                this.filteredYards.push(yard);
            } else {
                this.filteredYards.splice(index, 1);
            }

            this.loadShifts();
        },
        hasYard: function (yard) {
            return this.filteredYards.indexOf(yard) > -1;
        },
        saveOrder: function () {
            this.$refs.ordersref.save();
            this.loadShifts();
        },
        getDispatchReport: function (excel, noAllocation) {
            console.log('Printing...' + this.header['ShiftId']);
            this.$store.state.isLoading = true;
            var str = this.$store;

            if (this.header['ShiftId'] != null) {
                var params;
                if (noAllocation) {
                    params = {
                        shift_header: this.header['ShiftId'],
                        excel: 0,
                        no_allocation: 1
                    };
                } else {
                    params = {
                        shift_header: this.header['ShiftId'],
                        excel: 0,
                        no_allocation: null
                    };
                }
                axios({
                    url: 'shift-detail/dispatch-report',
                    method: 'post',
                    data: params,
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        if (excel == true) {
                            if (noAllocation) {
                                link.setAttribute(
                                    'download',
                                    'No Allocation Report.xlsx'
                                );
                            } else {
                                link.setAttribute(
                                    'download',
                                    'Dispatch Report.xlsx'
                                );
                            }
                        } else {
                            if (noAllocation) {
                                link.setAttribute(
                                    'download',
                                    'No Allocation Report.pdf'
                                );
                            } else {
                                link.setAttribute(
                                    'download',
                                    'Dispatch Report.pdf'
                                );
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function (error) {
                        str.state.isLoading = false;
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }

            console.log(this.$store.state.isLoading);
        },
        sortOrderDown: function () {
            console.log(this.orders);
            this.orders.sort(function (a, b) {
                if (a.OrderID > b.OrderID) {
                    return -1;
                }
                return 0;
            });
        },
        sortOrderUp: function () {
            console.log(this.orders);
            this.orders.sort(function (a, b) {
                if (a.OrderID < b.OrderID) {
                    return -1;
                }
                return 0;
            });
        },
        sortTerminalDown: function () {
            console.log(this.orders);
            this.orders.sort(function (a, b) {
                const t1 = a.Terminal.toLowerCase();
                const t2 = b.Terminal.toLowerCase();
                if (t1 > t2) {
                    return -1;
                }
                return 0;
            });
            console.log(this.orders);
        },
        sortTerminalUp: function () {
            console.log(this.orders);
            this.orders.sort(function (a, b) {
                const t1 = a.Terminal.toLowerCase();
                const t2 = b.Terminal.toLowerCase();
                if (t1 < t2) {
                    return -1;
                }
                return 0;
            });
            console.log(this.orders);
        },
        sortStationDown: function () {
            console.log(this.orders);
            this.orders.sort(function (a, b) {
                const t1 = a.Station.toLowerCase();
                const t2 = b.Station.toLowerCase();
                if (t1 > t2) {
                    return -1;
                }
                return 0;
            });
            console.log(this.orders);
        },
        sortStationUp: function () {
            console.log(this.orders);
            this.orders.sort(function (a, b) {
                const t1 = a.Station.toLowerCase();
                const t2 = b.Station.toLowerCase();
                if (t1 < t2) {
                    return -1;
                }
                return 0;
            });
            console.log(this.orders);
        },
        sortCityDown: function () {
            console.log(this.orders);
            this.orders.sort(function (a, b) {
                const t1 = a.StationCity.toLowerCase();
                const t2 = b.StationCity.toLowerCase();
                if (t1 > t2) {
                    return -1;
                }
                return 0;
            });
            console.log(this.orders);
        },
        sortCityUp: function () {
            console.log(this.orders);
            this.orders.sort(function (a, b) {
                const t1 = a.StationCity.toLowerCase();
                const t2 = b.StationCity.toLowerCase();
                if (t1 < t2) {
                    return -1;
                }
                return 0;
            });
            console.log(this.orders);
        },
        getDriverMailInterface: async function ($shift) {
            console.log('Printing...' + this.header['ShiftId']);
            var str = this.$store;
            this.$store.state.isLoading = true;

            if (this.header['ShiftId'] != null) {
                axios({
                    url: 'shift-detail/driver-report/' + $shift,
                    method: 'GET',
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'DriversMail.pdf');
                        document.body.appendChild(link);
                        link.click();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function (error) {
                        this.$store.state.isLoading = false;
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }

            console.log(this.$store.state.isLoading);
        },
        getDriverMail: async function ($shift, index) {
            //var str = this.$store;

            if (this.shifts[index].DriverEleosApp == 1) {
                let isSynchronized = await this.checkSyncPlatforms(
                    $shift,
                    'not-apply',
                    'tools'
                );
                if (isSynchronized) {
                    console.log('Dentro del if');
                    await this.getDriverMailInterface($shift);
                }
            } else {
                console.log('Dentro del else');
                await this.getDriverMailInterface($shift);
            }
        },
        openComentDialog: function ($commentType, $shift) {
            console.log($shift);
            if ($commentType == 'shift') {
                this.comment = $shift.ShiftAssmtComments;
                this.shift = $shift;
            }
            if ($commentType == 'header') {
                this.comment = this.headerComment;
            }
            this.commentDialog = true;
            this.commentType = $commentType;
        },
        saveComment: function () {
            var params = {};

            if (this.commentType == 'header') {
                params = {
                    ShiftComments: this.comment
                };
                axios
                    .put('shift-header/' + this.header.ShiftId, params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log(response);
                        this.commentDialog = false;
                    })
                    .catch(function (error) {
                        this.$store.state.isLoading = false;
                        console.log(error);
                    });
            }

            if (this.commentType == 'shift') {
                params = {
                    ShiftAssmtComments: this.comment
                };
                axios
                    .put('shift-detail/' + this.shift.ShiftDetail, params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log(response);
                        this.commentDialog = false;
                    })
                    .catch(function (error) {
                        this.$store.state.isLoading = false;
                        console.log(error);
                    });
            }
            this.loadShifts(true);
        },
        async dltOrdersConfirm() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete orders',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteOrders();
            }
        },
        FinalizeShift: function (itm) {
            console.log(itm);
            var parms = {
                DispatchFinalize: 0
            };
            var str = this.$store;
            axios
                .put('shift-detail/' + itm, parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save Successfully'
                    });
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        deleteOrders: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post(
                    'order/all/retain',
                    {},
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Orders removed successfully.'
                    });
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error.response);
                    console.log(error.response.status);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    if (error.response.status == 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Failed to delete order, already dispatched.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
<style scoped>
@import '~vue-context/dist/css/vue-context.css';
.v-application ul {
    padding: 0px;
}
.handle {
    cursor: move !important;
    cursor: -webkit-grabbing !important;
}

.shiftText {
    font-size: 12.5px;
    margin: 0;
}

.margins {
    margin: 0xp 0px 0px 0px;
    padding-top: 0xp 0px 0px 0px;
}

div.shifts2 {
    width: 2%;
}

div.shifts5 {
    width: 5%;
}

div.shifts20 {
    width: 20%;
}

div.shifts25 {
    width: 25%;
}

div.shifts10 {
    width: 10%;
}

div.shifts15 {
    width: 15%;
}

.orderText {
    font-size: 10.5px;
    border-bottom: 1px solid lightgrey;
}

.unfinished-load {
    font-size: 10.5px;
    border-bottom: 1px solid lightgrey;
    cursor: grab;
}

.finished-load {
    font-size: 10.5px;
    border-bottom: 1px solid lightgrey;
    cursor: not-allowed;
}

.lineUpHeader {}

.yardSelected {
    border-style: double;
    border-color: lightgrey;
}

.spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
}

.sk-chase {
    width: 40px;
    height: 40px;
    position: relative;
    animation: sk-chase 2.5s infinite linear both;
}

.sk-chase-dot {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    animation: sk-chase-dot 2s infinite ease-in-out both;
}

.sk-chase-dot:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: #4f83cc;
    border-radius: 100%;
    animation: sk-chase-dot-before 2s infinite ease-in-out both;
}

.sk-chase-dot:nth-child(1) {
    animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2) {
    animation-delay: -1s;
}

.sk-chase-dot:nth-child(3) {
    animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4) {
    animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5) {
    animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6) {
    animation-delay: -0.6s;
}

.sk-chase-dot:nth-child(1):before {
    animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2):before {
    animation-delay: -1s;
}

.sk-chase-dot:nth-child(3):before {
    animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4):before {
    animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5):before {
    animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6):before {
    animation-delay: -0.6s;
}

@keyframes sk-chase {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes sk-chase-dot {

    80%,
    100% {
        transform: rotate(360deg);
    }
}

@keyframes sk-chase-dot-before {
    50% {
        transform: scale(0.4);
    }

    100%,
    0% {
        transform: scale(1);
    }
}

.report-titles-container {
    cursor: pointer;
}

.report-titles-container:hover {
    background-color: #e1e1e1;
}

.marpad-0 {
    margin: 0;
    padding: 0;
}
</style>

